(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-grid"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__ofvCollectionFilterEnhancementsBound) return;
  window.__ofvCollectionFilterEnhancementsBound = true;

  var DRAWER_SELECTOR = '#FilterDrawer';
  var FILTER_FIELD_SELECTOR =
    'input[name^="filter."], select[name^="filter."]';

  var pendingDrawerState = null;
  var drawerGhost = null;
  var drawerRestoreTimer = null;
  var loadingSafetyTimer = null;

  function getCollectionGrid() {
    return document.querySelector('.ofv-collection-grid');
  }

  function getDrawerSkeletonTitleTarget(drawer) {
    if (!drawer) return null;

    var directTitle =
      drawer.querySelector('.drawer__title') ||
      drawer.querySelector('.drawer__header h1') ||
      drawer.querySelector('.drawer__header h2') ||
      drawer.querySelector('.drawer__header h3') ||
      drawer.querySelector('.drawer__header h4');

    if (directTitle) {
      var nestedTitle = directTitle.querySelector
        ? directTitle.querySelector(
            'h1, h2, h3, h4, [class*="title"], strong, span, p'
          )
        : null;

      if (
        nestedTitle &&
        nestedTitle !== directTitle &&
        String(nestedTitle.textContent || '').trim()
      ) {
        return nestedTitle;
      }

      return directTitle;
    }

    var header = drawer.querySelector('.drawer__header');

    if (header) {
      var candidates = header.querySelectorAll(
        'h1, h2, h3, h4, strong, span, p, div'
      );

      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        var titleText = String(candidate.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        if (titleText === 'filter' || titleText === 'filters') {
          return candidate;
        }
      }
    }

    return null;
  }

  function getDrawerActiveFilterChipTargets(drawer) {
    if (!drawer) return [];

    return Array.prototype.slice.call(
      drawer.querySelectorAll(
        '.ofv-drawer-active-filter-bar .ofv-drawer-active-filter-chip'
      )
    ).filter(function (chip) {
      if (!chip || !chip.getBoundingClientRect) return false;

      var rect = chip.getBoundingClientRect();
      var style = window.getComputedStyle(chip);

      return (
        rect.width > 4 &&
        rect.height > 4 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0'
      );
    });
  }

  function skeletonNodesAreRelated(a, b) {
    if (!a || !b) return false;

    return (
      a === b ||
      (a.contains && a.contains(b)) ||
      (b.contains && b.contains(a))
    );
  }

  function getDrawerSkeletonTargets(drawer) {
    if (!drawer) return [];

    var titleTarget = getDrawerSkeletonTitleTarget(drawer);
    var closeTarget = getDrawerCloseButton(drawer);

    var selectors = [
      '.collapsible-trigger',
      'summary',
      'legend',
      'label',
      'button',
      'select',
      'input[type="range"]',
      'input[type="number"]',
      'input[type="text"]',
      'a'
    ];

    var nodes = Array.prototype.slice.call(
      drawer.querySelectorAll(selectors.join(','))
    );

    return nodes.filter(function (node, index) {
      if (!node || !node.getBoundingClientRect) return false;
      if (node.closest('.ofv-drawer-loading-skeleton')) return false;

      if (node.closest('.ofv-filter-apply')) return false;

      if (node.closest('.ofv-drawer-active-filter-bar')) return false;

      if (titleTarget && skeletonNodesAreRelated(node, titleTarget)) {
        return false;
      }

      if (closeTarget && skeletonNodesAreRelated(node, closeTarget)) {
        return false;
      }

      var rect = node.getBoundingClientRect();
      var style = window.getComputedStyle(node);

      if (
        rect.width < 8 ||
        rect.height < 6 ||
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.opacity === '0'
      ) {
        return false;
      }

      var drawerRect = drawer.getBoundingClientRect();

      if (
        rect.right <= drawerRect.left ||
        rect.left >= drawerRect.right ||
        rect.bottom <= drawerRect.top ||
        rect.top >= drawerRect.bottom
      ) {
        return false;
      }

      for (var i = 0; i < nodes.length; i += 1) {
        if (i === index) continue;

        var parent = nodes[i];
        if (!parent || !parent.contains || !parent.contains(node)) continue;
        if (parent.closest('.ofv-drawer-active-filter-bar')) continue;
        if (titleTarget && skeletonNodesAreRelated(parent, titleTarget)) continue;
        if (closeTarget && skeletonNodesAreRelated(parent, closeTarget)) continue;

        var parentTag = (parent.tagName || '').toLowerCase();
        var parentIsControl =
          parentTag === 'button' ||
          parentTag === 'summary' ||
          parentTag === 'label' ||
          parentTag === 'a' ||
          parent.classList.contains('collapsible-trigger');

        if (!parentIsControl) continue;

        var parentRect = parent.getBoundingClientRect();

        if (
          parentRect.width >= rect.width &&
          parentRect.height >= rect.height &&
          Math.abs(parentRect.left - rect.left) < 8 &&
          Math.abs(parentRect.top - rect.top) < 8
        ) {
          return false;
        }
      }

      return true;
    });
  }

  function getDrawerSkeletonRow(target, drawerRect, kind) {
    if (!target || !drawerRect || !target.getBoundingClientRect) {
      return null;
    }

    var rect = target.getBoundingClientRect();
    var style = window.getComputedStyle(target);

    if (
      rect.width < 4 ||
      rect.height < 4 ||
      style.display === 'none' ||
      style.visibility === 'hidden'
    ) {
      return null;
    }

    var clippedLeft = Math.max(rect.left, drawerRect.left);
    var clippedTop = Math.max(rect.top, drawerRect.top);
    var clippedRight = Math.min(rect.right, drawerRect.right);
    var clippedBottom = Math.min(rect.bottom, drawerRect.bottom);

    var visibleWidth = Math.max(0, clippedRight - clippedLeft);
    var visibleHeight = Math.max(0, clippedBottom - clippedTop);

    if (visibleWidth < 4 || visibleHeight < 4) return null;

    var relativeLeft = clippedLeft - drawerRect.left;
    var relativeTop = clippedTop - drawerRect.top;

    if (kind === 'title') {
      var titleHeight = Math.min(12, Math.max(10, visibleHeight * 0.5));
      var titleWidth = Math.min(
        Math.max(58, Math.min(visibleWidth * 0.9, 92)),
        drawerRect.width - relativeLeft - 70
      );

      return {
        left: relativeLeft,
        top: relativeTop + Math.max(0, (visibleHeight - titleHeight) / 2),
        width: Math.max(44, titleWidth),
        height: titleHeight,
        kind: 'title',
        isControl: false,
        locked: true
      };
    }

    if (kind === 'close') {
      var closeSize = Math.max(
        24,
        Math.min(30, Math.min(visibleWidth, visibleHeight))
      );

      return {
        left:
          relativeLeft + Math.max(0, (visibleWidth - closeSize) / 2),
        top:
          relativeTop + Math.max(0, (visibleHeight - closeSize) / 2),
        width: closeSize,
        height: closeSize,
        kind: 'close',
        isControl: true,
        locked: true
      };
    }

    if (kind === 'active-chip') {

      return {
        left: relativeLeft,
        top: relativeTop,
        width: visibleWidth,
        height: visibleHeight,
        kind: 'active-chip',
        isControl: true,
        locked: true
      };
    }

    var tag = (target.tagName || '').toLowerCase();
    var isControl =
      tag === 'button' ||
      tag === 'select' ||
      tag === 'summary' ||
      target.classList.contains('collapsible-trigger');

    var isRange =
      tag === 'input' &&
      String(target.type || '').toLowerCase() === 'range';

    var isTextInput =
      tag === 'input' &&
      (
        String(target.type || '').toLowerCase() === 'number' ||
        String(target.type || '').toLowerCase() === 'text'
      );

    var left = relativeLeft;
    var top = relativeTop;
    var width = visibleWidth;
    var height = visibleHeight;

    if (isControl || isTextInput) {

      var controlHeight = Math.min(44, Math.max(28, visibleHeight));
      top += Math.max(0, (visibleHeight - controlHeight) / 2);
      height = controlHeight;
    } else if (isRange) {

      height = Math.max(6, Math.min(visibleHeight, 12));
      top += Math.max(0, (visibleHeight - height) / 2);
    } else {

      var lineHeight = Math.max(9, Math.min(11, visibleHeight * 0.45));
      var lineWidth = Math.min(
        visibleWidth,
        Math.max(54, Math.min(visibleWidth * 0.72, 190))
      );

      top += Math.max(0, (visibleHeight - lineHeight) / 2);
      width = lineWidth;
      height = lineHeight;
    }

    return {
      left: left,
      top: top,
      width: width,
      height: height,
      kind: 'generic',
      isControl: isControl || isTextInput || isRange,
      locked: false
    };
  }

  function skeletonRowsNearlyEqual(a, b) {
    if (!a || !b) return false;

    return (
      Math.abs(a.left - b.left) < 4 &&
      Math.abs(a.top - b.top) < 4 &&
      Math.abs(a.width - b.width) < 8 &&
      Math.abs(a.height - b.height) < 6
    );
  }

  function ensureDrawerLoadingSkeleton(drawer) {
    if (!drawer) return null;

    var overlay = drawer.querySelector('.ofv-drawer-loading-skeleton');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ofv-drawer-loading-skeleton';
      overlay.setAttribute('aria-hidden', 'true');
      drawer.appendChild(overlay);
    }

    overlay.innerHTML = '';

    var drawerRect = drawer.getBoundingClientRect();
    var titleTarget = getDrawerSkeletonTitleTarget(drawer);
    var closeTarget = getDrawerCloseButton(drawer);
    var activeChipTargets = getDrawerActiveFilterChipTargets(drawer);
    var viewProductsTarget =
      drawer.querySelector('.ofv-filter-apply__button');
    var viewProductsBar =
      viewProductsTarget
        ? viewProductsTarget.closest('.ofv-filter-apply')
        : null;

    var rows = [];

    var hasStickyAppliedFilters =
      activeChipTargets.length > 0;

    var activeFilterBar =
      hasStickyAppliedFilters
        ? drawer.querySelector('.ofv-drawer-active-filter-bar')
        : null;

    var activeFilterBarRect =
      activeFilterBar &&
      activeFilterBar.getBoundingClientRect
        ? activeFilterBar.getBoundingClientRect()
        : null;

    var viewProductsBarRect =
      viewProductsBar &&
      viewProductsBar.getBoundingClientRect
        ? viewProductsBar.getBoundingClientRect()
        : null;

    overlay.setAttribute(
      'data-ofv-skeleton-mode',
      hasStickyAppliedFilters
        ? 'full-drawer-with-sticky-filters'
        : 'full-drawer'
    );

    function rowOverlapsProtectedRect(row, protectedRect, buffer) {
      if (!row || !protectedRect) return false;

      var rowLeft =
        drawerRect.left + row.left;

      var rowTop =
        drawerRect.top + row.top;

      var rowRight =
        rowLeft + row.width;

      var rowBottom =
        rowTop + row.height;

      var safeBuffer =
        Number.isFinite(buffer) ? buffer : 2;

      var protectedLeft =
        Math.max(drawerRect.left, protectedRect.left) - safeBuffer;

      var protectedTop =
        Math.max(drawerRect.top, protectedRect.top) - safeBuffer;

      var protectedRight =
        Math.min(drawerRect.right, protectedRect.right) + safeBuffer;

      var protectedBottom =
        Math.min(drawerRect.bottom, protectedRect.bottom) + safeBuffer;

      return (
        rowRight > protectedLeft &&
        rowLeft < protectedRight &&
        rowBottom > protectedTop &&
        rowTop < protectedBottom
      );
    }

    function rowOverlapsStickyFilterBar(row) {
      if (!hasStickyAppliedFilters) return false;
      return rowOverlapsProtectedRect(
        row,
        activeFilterBarRect,
        2
      );
    }

    function rowOverlapsViewProductsBar(row) {
      return rowOverlapsProtectedRect(
        row,
        viewProductsBarRect,
        2
      );
    }

    var genericTargets =
      getDrawerSkeletonTargets(drawer);

    var titleRow = getDrawerSkeletonRow(
      titleTarget,
      drawerRect,
      'title'
    );

    var closeRow = getDrawerSkeletonRow(
      closeTarget,
      drawerRect,
      'close'
    );

    if (
      titleRow &&
      !rowOverlapsStickyFilterBar(titleRow) &&
      !rowOverlapsViewProductsBar(titleRow)
    ) {
      rows.push(titleRow);
    }

    if (
      closeRow &&
      !rowOverlapsStickyFilterBar(closeRow) &&
      !rowOverlapsViewProductsBar(closeRow)
    ) {
      rows.push(closeRow);
    }

    var viewProductsRow = getDrawerSkeletonRow(
      viewProductsTarget,
      drawerRect,
      'view-button'
    );

    if (viewProductsRow) {
      rows.push(viewProductsRow);
    }

    if (hasStickyAppliedFilters) {
      activeChipTargets.forEach(function (chip) {
        var row = getDrawerSkeletonRow(
          chip,
          drawerRect,
          'active-chip'
        );

        if (row) rows.push(row);
      });
    }

    genericTargets.forEach(function (target) {
      var row = getDrawerSkeletonRow(
        target,
        drawerRect,
        'generic'
      );

      if (!row) return;

      if (
        rowOverlapsStickyFilterBar(row) ||
        rowOverlapsViewProductsBar(row)
      ) {
        return;
      }

      var duplicate = rows.some(function (existing) {
        return skeletonRowsNearlyEqual(existing, row);
      });

      if (!duplicate) rows.push(row);
    });

    rows.sort(function (a, b) {
      if (Math.abs(a.top - b.top) > 2) return a.top - b.top;
      return a.left - b.left;
    });

    rows.forEach(function (row) {
      if (
        row.left + row.width <= 0 ||
        row.top + row.height <= 0 ||
        row.left >= drawerRect.width ||
        row.top >= drawerRect.height
      ) {
        return;
      }

      var box = document.createElement('div');
      box.className = 'ofv-drawer-skeleton-box';

      if (row.isControl) {
        box.classList.add('ofv-drawer-skeleton-box--control');
      }

      if (row.kind === 'title') {
        box.classList.add('ofv-drawer-skeleton-box--title');
      }

      if (row.kind === 'close') {
        box.classList.add('ofv-drawer-skeleton-box--close');
      }

      if (row.kind === 'active-chip') {
        box.classList.add('ofv-drawer-skeleton-box--active-chip');
      }

      if (row.kind === 'view-button') {
        box.classList.add('ofv-drawer-skeleton-box--view-button');
      }

      box.style.left = row.left + 'px';
      box.style.top = row.top + 'px';
      box.style.width = row.width + 'px';
      box.style.height = row.height + 'px';

      overlay.appendChild(box);
    });

    return overlay;
  }

  function showFilterLoadingSkeleton() {
    var grid = getCollectionGrid();
    var drawer = getDrawer();

    if (grid) {
      if (!grid.classList.contains('ofv-is-filter-loading')) {
        var loadingHeight = grid.offsetHeight;
        if (loadingHeight > 0) grid.style.minHeight = loadingHeight + 'px';
      }
      grid.classList.add('ofv-is-filter-loading');
    }

    if (drawer) {
      ensureDrawerLoadingSkeleton(drawer);
      drawer.classList.add('ofv-is-filter-loading');

      window.requestAnimationFrame(function () {
        if (drawer.classList.contains('ofv-is-filter-loading')) {
          ensureDrawerLoadingSkeleton(drawer);
        }
      });
    }

    if (!grid && !drawer) return;

    if (loadingSafetyTimer) {
      window.clearTimeout(loadingSafetyTimer);
    }

    loadingSafetyTimer = window.setTimeout(function () {
      clearFilterLoadingSkeleton();
      pendingDrawerState = null;
      removeDrawerGhost();
    }, 6000);
  }

  function clearFilterLoadingSkeleton() {
    var grids = document.querySelectorAll('.ofv-collection-grid');
    var drawers = document.querySelectorAll('#FilterDrawer');

    grids.forEach(function (grid) {
      grid.classList.remove('ofv-is-filter-loading', 'unload');
      grid.style.minHeight = '';
    });

    drawers.forEach(function (drawer) {
      drawer.classList.remove('ofv-is-filter-loading', 'ofv-is-sort-loading');
    });

    if (loadingSafetyTimer) {
      window.clearTimeout(loadingSafetyTimer);
      loadingSafetyTimer = null;
    }
  }

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function normalizeUrlForMatch(url) {
    if (!url) return '';

    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname + parsed.search;
    } catch (error) {
      return String(url);
    }
  }

  function getActiveFilterSourceItems() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.ofv-active-filter-source .ofv-active-filter-source__item'
      )
    );
  }

  function hideNativeDrawerActiveFilters(drawer) {
    if (!drawer) return;

    var sourceItems = getActiveFilterSourceItems();

    if (!sourceItems.length) return;

    var removeUrls = sourceItems.map(function (item) {
      return normalizeUrlForMatch(item.getAttribute('href'));
    });

    var links = drawer.querySelectorAll('a[href]');

    Array.prototype.forEach.call(links, function (link) {
      if (link.closest('.ofv-drawer-active-filter-bar')) return;

      var href = normalizeUrlForMatch(link.getAttribute('href'));

      if (removeUrls.indexOf(href) === -1) return;

      if (
        link.closest('label') ||
        link.closest('[role="checkbox"]') ||
        link.closest('[role="radio"]') ||
        (
          link.parentElement &&
          link.parentElement.querySelector(
            'input[type="checkbox"], input[type="radio"], select'
          )
        )
      ) {
        return;
      }

      var target = link;
      var parent = link.parentElement;

      if (
        parent &&
        !parent.querySelector(
          'input[type="checkbox"], input[type="radio"], select'
        ) &&
        parent.children.length <= 3
      ) {
        target = parent;
      }

      target.setAttribute('data-ofv-native-active-hidden', 'true');
      target.style.display = 'none';
    });
  }

  function findNativeRemoveLink(drawer, url) {
    if (!drawer || !url) return null;

    var targetUrl = normalizeUrlForMatch(url);
    var links = drawer.querySelectorAll('a[href]');

    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];

      if (link.closest('.ofv-drawer-active-filter-bar')) continue;

      if (
        normalizeUrlForMatch(link.getAttribute('href')) === targetUrl
      ) {
        return link;
      }
    }

    return null;
  }

  function ensureDrawerActiveFilterBar(drawer) {
    if (!drawer) return null;

    var form = getFilterForm(drawer);
    if (!form) return null;

    prepareDrawerFacetPresentation(drawer);
    ensureCaseInsensitiveColorGroups(drawer);
    ensureGroupedSizeFilters(drawer);
    hideZeroResultFilterOptions(drawer);
    removeSelectedFacetOptionCounts(drawer);

    var sourceItems = getActiveFilterSourceItems();
    var existing = drawer.querySelector('.ofv-drawer-active-filter-bar');

    var hasAppliedFilters =
      sourceItems.some(function (sourceItem) {
        return !sourceItem.hasAttribute(
          'data-ofv-clear-filters'
        );
      });

    drawer.classList.toggle(
      'ofv-has-applied-filters',
      hasAppliedFilters
    );

    var groupedSourceItems = [];
    var seenGroupedKeys = {};

    sourceItems.forEach(function (sourceItem) {
      if (sourceItem.hasAttribute('data-ofv-clear-filters')) {
        groupedSourceItems.push({
          primary: sourceItem,
          items: [sourceItem],
          groupType: 'clear',
          displayLabel: 'Clear All'
        });
        return;
      }

      var filterName =
        sourceItem.getAttribute('data-ofv-filter-name') || '';

      var filterValue =
        sourceItem.getAttribute('data-ofv-filter-value') ||
        sourceItem.getAttribute('data-ofv-active-label') ||
        '';

      var groupType = '';
      var groupKey = '';
      var displayLabel = '';

      if (isColorFilterName(filterName)) {
        var colorInfo = getCanonicalColorInfo(filterValue);

        groupType = 'color';
        groupKey =
          'color||' +
          colorInfo.key;
        displayLabel = colorInfo.label;
      } else if (isSizeFilterName(filterName)) {
        var sizeInfo = getCanonicalSizeInfo(filterValue);

        groupType = 'size';
        groupKey =
          'size||' +
          sizeInfo.key;
        displayLabel = sizeInfo.label;
      }

      if (!groupType) {
        groupedSourceItems.push({
          primary: sourceItem,
          items: [sourceItem],
          groupType: 'other',
          displayLabel: ''
        });
        return;
      }

      if (!seenGroupedKeys[groupKey]) {
        seenGroupedKeys[groupKey] = {
          primary: sourceItem,
          items: [],
          groupType: groupType,
          displayLabel: displayLabel
        };

        groupedSourceItems.push(seenGroupedKeys[groupKey]);
      }

      seenGroupedKeys[groupKey].items.push(sourceItem);

      if (groupType === 'size') {
        var preferredLabel =
          normalizeCaseInsensitiveValue(displayLabel);

        var currentPrimaryValue =
          normalizeCaseInsensitiveValue(
            seenGroupedKeys[groupKey].primary.getAttribute('data-ofv-filter-value') ||
            seenGroupedKeys[groupKey].primary.getAttribute('data-ofv-active-label') ||
            ''
          );

        var incomingValue =
          normalizeCaseInsensitiveValue(filterValue);

        if (
          incomingValue === preferredLabel &&
          currentPrimaryValue !== preferredLabel
        ) {
          seenGroupedKeys[groupKey].primary = sourceItem;
        }
      }
    });

    if (!sourceItems.length) {
      drawer.classList.remove(
        'ofv-has-applied-filters'
      );

      if (existing) existing.remove();
      return null;
    }

    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'ofv-drawer-active-filter-bar';
      existing.setAttribute('aria-label', 'Applied filters');
    }

    var scrollable = drawer.querySelector('.drawer__scrollable');
    var drawerSortSection = scrollable
      ? scrollable.querySelector('.ofv-drawer-sort-section')
      : null;

    if (
      scrollable &&
      drawerSortSection &&
      drawerSortSection.parentElement === scrollable
    ) {
      scrollable.insertBefore(existing, drawerSortSection);
    } else if (scrollable && scrollable.contains(form)) {
      var formBranch = form;

      while (
        formBranch.parentElement &&
        formBranch.parentElement !== scrollable
      ) {
        formBranch = formBranch.parentElement;
      }

      if (formBranch.parentElement === scrollable) {
        scrollable.insertBefore(existing, formBranch);
      }
    } else if (form.parentElement) {
      form.parentElement.insertBefore(existing, form);
    }

    existing.innerHTML = '';

    groupedSourceItems.forEach(function (sourceGroup) {
      var sourceItem = sourceGroup.primary;

      var label =
        sourceGroup.displayLabel ||
        sourceItem.getAttribute('data-ofv-active-label') ||
        sourceItem.textContent.trim();

      var url = sourceItem.getAttribute('href');
      var isClear = sourceItem.hasAttribute('data-ofv-clear-filters');

      var isGroupedCaseInsensitiveColor =
        !isClear &&
        sourceGroup.groupType === 'color' &&
        sourceGroup.items.length > 1;

      var isGroupedSize =
        !isClear &&
        sourceGroup.groupType === 'size' &&
        sourceGroup.items.length > 1;

      var chip = document.createElement('a');
      chip.href = url;
      chip.className = 'ofv-drawer-active-filter-chip';

      if (isClear) {
        chip.classList.add('ofv-drawer-active-filter-chip--clear');
        chip.setAttribute('aria-label', 'Clear all filters');
      } else {
        chip.setAttribute(
          'aria-label',
          'Remove ' + label + ' filter'
        );
      }

      var labelNode = document.createElement('span');
      labelNode.className = 'ofv-drawer-active-filter-chip__label';
      labelNode.textContent = label;

      var removeNode = document.createElement('span');
      removeNode.className = 'ofv-drawer-active-filter-chip__remove';
      removeNode.setAttribute('aria-hidden', 'true');
      removeNode.textContent = '×';

      chip.appendChild(labelNode);
      chip.appendChild(removeNode);

      chip.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (
          isGroupedCaseInsensitiveColor &&
          applyGroupedColorRemoval(sourceItem)
        ) {
          return;
        }

        if (
          isGroupedSize &&
          applyGroupedSizeRemoval(sourceItem)
        ) {
          return;
        }

        showFilterLoadingSkeleton();
        captureDrawerState();

        var currentDrawer = getDrawer() || drawer;
        var nativeLink = findNativeRemoveLink(currentDrawer, url);

        if (nativeLink) {
          nativeLink.click();
          return;
        }

        window.location.assign(url);
      });

      existing.appendChild(chip);
    });

    var stickyClose =
      document.createElement('button');

    stickyClose.type = 'button';
    stickyClose.className = 'ofv-drawer-sticky-close';
    stickyClose.setAttribute('aria-label', 'Close filters');
    stickyClose.textContent = '×';

    stickyClose.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      cancelDrawerPersistence();

      window.requestAnimationFrame(function () {
        closeDrawer(getDrawer() || drawer);
      });
    });

    existing.appendChild(stickyClose);

    syncStickyBarToScrollport(
      drawer
    );

    hideNativeDrawerActiveFilters(drawer);

    return existing;
  }

  function getFilterForm(drawer) {
    if (!drawer) return null;
    return drawer.querySelector('form');
  }

  function isDrawerFilterField(target) {
    if (!target || !target.matches) return false;
    if (!target.matches(FILTER_FIELD_SELECTOR)) return false;
    return !!target.closest(DRAWER_SELECTOR);
  }

  function normalizeCaseInsensitiveValue(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase();
  }

  function normalizeOfvFilterSwatchColorKey(value) {
    var lower = String(value || '')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase();

    if (!lower) return '';

    lower = lower
      .replace(/^\(\s*1\s*\)\s*/, '')
      .replace(/^black\s*-?\s*93$/, 'black')
      .replace(/^fushia$/, 'fuchsia')
      .replace(/^fuschia$/, 'fuchsia')
      .replace(/^cammello$/, 'camel')
      .replace(/^royal$/, 'royal blue')
      .replace(/^coralle$/, 'coral')
      .replace(/^corallo$/, 'coral')
      .replace(/^charocoal$/, 'charcoal')
      .replace(/^rasberry$/, 'raspberry');

    return lower
      .replace(/[.’'()]/g, '')
      .replace(/[^a-z0-9]+/g, '');
  }

  function getOfvFilterColorPresetHex(value) {
    var key = normalizeOfvFilterSwatchColorKey(value);
    if (!key) return '';

    var presets = {
      "black": "#000000",
      "black93": "#000000",
      "white": "#FFFFFF",
      "1white": "#FFFFFF",
      "offwhite": "#F5F2E8",
      "ivory": "#F4EEDC",
      "cream": "#EFE6D1",
      "whitebeige": "#E6D9C4",
      "natural": "#D9CDBB",
      "nude": "#D8B7A0",
      "beige": "#D8C4A5",
      "stone": "#B6AD9F",
      "sand": "#D5C2A3",
      "oatmeal": "#D7CBB6",
      "oyster": "#D8D2C7",
      "fango": "#736B64",
      "taupe": "#9A8878",
      "darktaupe": "#6B5F58",
      "camel": "#B68A5A",
      "tan": "#C4A477",
      "khaki": "#A69A73",
      "brown": "#6B4A35",
      "chocolate": "#5B3828",
      "mocha": "#635150",
      "caramel": "#B27A4A",
      "cognac": "#9A5A36",
      "cinnamon": "#A56B4F",
      "rust": "#A85C3F",
      "brick": "#A4513B",
      "maroonbrown": "#70443F",
      "grey": "#A5A5A5",
      "gray": "#A5A5A5",
      "darkgrey": "#57595C",
      "darkgray": "#57595C",
      "charcoal": "#4C4C4C",
      "charocoal": "#4C4C4C",
      "lightgrey": "#C5C7C8",
      "lightgray": "#C5C7C8",
      "silver": "#B7B7B7",
      "silvergrey": "#B8BCC0",
      "silvergray": "#B8BCC0",
      "navy": "#17243D",
      "inknavy": "#17243D",
      "blue": "#416B9A",
      "denimblue": "#5F7895",
      "denim": "#5F7895",
      "jeans": "#5F7892",
      "royalblue": "#2F55AD",
      "cobalt": "#2F55AD",
      "skyblue": "#9EC7E5",
      "powderblue": "#B9CEF3",
      "softblue": "#A8BED4",
      "celeste": "#99B0E3",
      "celesteblue": "#99B0E3",
      "chambray": "#84A7C2",
      "dustyblue": "#7F9DB3",
      "iceblue": "#C6DDEB",
      "periwinkle": "#8D9ACB",
      "lightwash": "#AFC4D4",
      "midwash": "#6F8DA6",
      "darkwash": "#334E68",
      "teal": "#3F7F7B",
      "newteal": "#2E7472",
      "turquoise": "#01A6CB",
      "aqua": "#75C8C8",
      "seafoam": "#AFCDBD",
      "green": "#557A56",
      "newgreen": "#5E8B59",
      "sage": "#9CAA8B",
      "moss": "#727A51",
      "olive": "#74734A",
      "olivegreen": "#74764A",
      "darkgreen": "#3E5842",
      "military": "#6F7351",
      "militarygreen": "#646B45",
      "forest": "#527A41",
      "forestgreen": "#527A41",
      "biscaygreen": "#3C7774",
      "kellygreen": "#3F8A4D",
      "emerald": "#2F6B52",
      "jade": "#4E8B6B",
      "lime": "#768A30",
      "mint": "#D2E8C1",
      "polarpear": "#B9C65B",
      "pink": "#E6A6B5",
      "newpink": "#D9708B",
      "petal": "#D7A4AB",
      "dustypink": "#C8959F",
      "dustyrose": "#B97A84",
      "blush": "#D8A2A5",
      "rose": "#C97887",
      "salmon": "#D98678",
      "fuchsia": "#F025A0",
      "fushia": "#F025A0",
      "fuschia": "#F025A0",
      "magenta": "#B9397B",
      "coral": "#E88678",
      "peach": "#E8B49D",
      "raspberry": "#DD5881",
      "rasberry": "#DD5881",
      "purple": "#76547C",
      "lilac": "#B8A1C5",
      "lavender": "#B9A7D0",
      "newpurple": "#80618A",
      "plum": "#6A4468",
      "red": "#B93A3A",
      "persianred": "#C83A3E",
      "ruby": "#A62F46",
      "wine": "#733A49",
      "burgundy": "#6C2F3C",
      "maroon": "#74363D",
      "orange": "#D98245",
      "burntorange": "#B94B21",
      "mango": "#E99A3A",
      "yellow": "#E4C95B",
      "butteryellow": "#F2D77B",
      "mustard": "#DCA134",
      "honey": "#C79644",
      "gold": "#C2A358"
    };

    return Object.prototype.hasOwnProperty.call(presets, key)
      ? presets[key]
      : '';
  }

  function getOfvFilterColorSwatchVisual(value) {
    var original = String(value || '')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .trim();

    if (!original) return null;

    var lower = original.toLocaleLowerCase();

    if (
      lower === 'as seen' ||
      lower.indexOf('print') !== -1 ||
      /[&+]/.test(original)
    ) {
      return null;
    }

    var slashParts = original.split('/');

    if (slashParts.length === 2) {
      var firstHex = getOfvFilterColorPresetHex(slashParts[0]);
      var secondHex = getOfvFilterColorPresetHex(slashParts[1]);

      if (firstHex && secondHex) {
        return {
          type: 'split',
          firstHex: firstHex,
          secondHex: secondHex
        };
      }

      return null;
    }

    if (slashParts.length > 2) return null;

    var hex = getOfvFilterColorPresetHex(original);

    if (!hex) return null;

    return {
      type: 'solid',
      hex: hex
    };
  }

  function ofvHexIsLight(hex) {
    var clean = String(hex || '').replace('#', '').trim();
    if (!/^[0-9a-f]{6}$/i.test(clean)) return false;
    var r = parseInt(clean.slice(0, 2), 16);
    var g = parseInt(clean.slice(2, 4), 16);
    var b = parseInt(clean.slice(4, 6), 16);
    return ((r * 299 + g * 587 + b * 114) / 1000) >= 205;
  }

  function ensureColorOptionSwatch(input, root, canonicalLabel) {
    if (!input || !root) return;

    var labelElement = getInputLabelElement(input, root);
    if (!labelElement) return;

    var existing = labelElement.querySelector(
      '.ofv-filter-color-swatch[data-ofv-filter-color-swatch]'
    );

    var visual = getOfvFilterColorSwatchVisual(input.value);

    if (!visual) {
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
      return;
    }

    var swatch = existing || document.createElement('span');
    swatch.className = 'ofv-filter-color-swatch';
    swatch.setAttribute('data-ofv-filter-color-swatch', 'true');
    swatch.setAttribute('aria-hidden', 'true');

    swatch.style.removeProperty('background-color');
    swatch.style.removeProperty('background-image');
    swatch.removeAttribute('data-ofv-split-swatch');

    if (visual.type === 'split') {
      swatch.style.backgroundColor = visual.firstHex;
      swatch.style.backgroundImage =
        'linear-gradient(to right, ' +
        visual.firstHex +
        ' 0%, ' +
        visual.firstHex +
        ' 50%, ' +
        visual.secondHex +
        ' 50%, ' +
        visual.secondHex +
        ' 100%)';

      swatch.setAttribute('data-ofv-split-swatch', 'true');
      swatch.setAttribute(
        'data-ofv-light-swatch',
        (ofvHexIsLight(visual.firstHex) || ofvHexIsLight(visual.secondHex))
          ? 'true'
          : 'false'
      );
    } else {
      swatch.style.backgroundColor = visual.hex;
      swatch.style.backgroundImage = 'none';
      swatch.setAttribute(
        'data-ofv-light-swatch',
        ofvHexIsLight(visual.hex) ? 'true' : 'false'
      );
    }

    if (swatch.parentNode) return;

    var targetKey = getCanonicalColorInfo(input.value).key;
    var walker = document.createTreeWalker(
      labelElement,
      window.NodeFilter ? window.NodeFilter.SHOW_TEXT : 4,
      null
    );
    var textNode;

    while ((textNode = walker.nextNode())) {
      var raw = textNode.nodeValue || '';
      var withoutCount = raw.replace(/\s*\(\s*\d+\s*\)\s*$/, '');
      var candidate = withoutCount.replace(/\s+/g, ' ').trim();
      if (!candidate) continue;

      if (
        getCanonicalColorInfo(candidate).key !== targetKey &&
        normalizeCaseInsensitiveValue(candidate) !== normalizeCaseInsensitiveValue(canonicalLabel || '')
      ) {
        continue;
      }

      textNode.parentNode.insertBefore(swatch, textNode);
      return;
    }

    labelElement.appendChild(swatch);
  }

  function getCanonicalColorInfo(value) {
    var original = String(value || '')
      .replace(/\s+/g, ' ')
      .trim();

    var key = normalizeCaseInsensitiveValue(original)
      .replace(/[.’']/g, '')
      .replace(/[\s_-]+/g, '');

    var colorAliases = {
      'fushia': 'fuchsia',
      'fuschia': 'fuchsia',
      'gray': 'grey',
      'rasberry': 'raspberry',
      'charocoal': 'charcoal',
      'cammello': 'camel',
      'royal': 'royalblue',
      'coralle': 'coral',
      'corallo': 'coral'
    };

    if (Object.prototype.hasOwnProperty.call(colorAliases, key)) {
      key = colorAliases[key];
    }

    var canonicalLabels = {
      'black': 'Black',
      'white': 'White',
      'offwhite': 'Off White',
      'ivory': 'Ivory',
      'cream': 'Cream',
      'oyster': 'Oyster',
      'natural': 'Natural',
      'nude': 'Nude',
      'beige': 'Beige',
      'fango': 'Fango',
      'taupe': 'Taupe',
      'darktaupe': 'Dark Taupe',
      'camel': 'Camel',
      'tan': 'Tan',
      'khaki': 'Khaki',
      'brown': 'Brown',
      'chocolate': 'Chocolate',
      'cinnamon': 'Cinnamon',
      'brick': 'Brick',
      'maroonbrown': 'Maroon Brown',
      'lightgrey': 'Light Grey',
      'lightgray': 'Light Gray',
      'grey': 'Grey',
      'gray': 'Grey',
      'silvergrey': 'Silver Grey',
      'silvergray': 'Silver Gray',
      'darkgrey': 'Dark Grey',
      'darkgray': 'Dark Gray',
      'charcoal': 'Charcoal',
      'navy': 'Navy',
      'inknavy': 'Ink Navy',
      'blue': 'Blue',
      'denimblue': 'Denim Blue',
      'denim': 'Denim',
      'jeans': 'Jeans',
      'royalblue': 'Royal Blue',
      'cobalt': 'Cobalt',
      'skyblue': 'Sky Blue',
      'powderblue': 'Powder Blue',
      'softblue': 'Soft Blue',
      'celeste': 'Celeste',
      'celesteblue': 'Celeste Blue',
      'periwinkle': 'Periwinkle',
      'lightwash': 'Light Wash',
      'midwash': 'Mid Wash',
      'darkwash': 'Dark Wash',
      'teal': 'Teal',
      'newteal': 'New Teal',
      'turquoise': 'Turquoise',
      'aqua': 'Aqua',
      'seafoam': 'Seafoam',
      'green': 'Green',
      'newgreen': 'New Green',
      'sage': 'Sage',
      'moss': 'Moss',
      'olive': 'Olive',
      'olivegreen': 'Olive Green',
      'darkgreen': 'Dark Green',
      'military': 'Military',
      'militarygreen': 'Military Green',
      'forest': 'Forest',
      'forestgreen': 'Forest Green',
      'biscaygreen': 'Biscay Green',
      'kellygreen': 'Kelly Green',
      'lime': 'Lime',
      'polarpear': 'Polar Pear',
      'pink': 'Pink',
      'newpink': 'New Pink',
      'petal': 'Petal',
      'dustypink': 'Dusty Pink',
      'dustyrose': 'Dusty Rose',
      'fuchsia': 'Fuchsia',
      'magenta': 'Magenta',
      'coral': 'Coral',
      'salmon': 'Salmon',
      'peach': 'Peach',
      'raspberry': 'Raspberry',
      'purple': 'Purple',
      'lilac': 'Lilac',
      'newpurple': 'New Purple',
      'red': 'Red',
      'persianred': 'Persian Red',
      'ruby': 'Ruby',
      'wine': 'Wine',
      'burgundy': 'Burgundy',
      'maroon': 'Maroon',
      'orange': 'Orange',
      'burntorange': 'Burnt Orange',
      'mango': 'Mango',
      'yellow': 'Yellow',
      'butteryellow': 'Butter Yellow',
      'mustard': 'Mustard',
      'honey': 'Honey',
      'gold': 'Gold',
      'silver': 'Silver'
    };

    return {
      key: key,
      label: canonicalLabels[key] || original
    };
  }

  function isColorFilterName(name) {
    var normalized = normalizeCaseInsensitiveValue(name);
    return normalized.indexOf('color') !== -1 ||
      normalized.indexOf('colour') !== -1;
  }

  function isSizeFilterName(name) {
    return normalizeCaseInsensitiveValue(name).indexOf('size') !== -1;
  }

  function getColorFilterRoot(drawer) {
    if (!drawer) return null;

    var heading = findFilterHeading(drawer, 'color');

    if (!heading) return null;

    return (
      getControlledPanel(heading) ||
      heading.closest('fieldset') ||
      heading.parentElement
    );
  }

  function getSizeFilterRoot(drawer) {
    if (!drawer) return null;

    var heading = findFilterHeading(drawer, 'size');

    if (!heading) return null;

    return (
      getControlledPanel(heading) ||
      heading.closest('fieldset') ||
      heading.parentElement
    );
  }

  function getColorCheckboxes(drawer) {
    var root = getColorFilterRoot(drawer);
    if (!root) return [];

    return Array.prototype.slice.call(
      root.querySelectorAll('input[type="checkbox"][name^="filter."]')
    );
  }

  function getSizeCheckboxes(drawer) {
    var root = getSizeFilterRoot(drawer);
    if (!root) return [];

    return Array.prototype.slice.call(
      root.querySelectorAll('input[type="checkbox"][name^="filter."]')
    );
  }

  function getFilterOptionRow(input, root) {
    if (!input) return null;

    var row =
      input.closest('li') ||
      input.closest('[data-filter-item]') ||
      input.closest('.tag') ||
      input.closest('.filter-item') ||
      input.closest('label');

    if (!row || row === root) {
      row = input.closest('label') || input.parentElement;
    }

    return row;
  }

  function getFacetRootByName(drawer, filterName) {
    if (!drawer || !filterName) return null;

    var heading = findFilterHeading(drawer, filterName);

    if (!heading && filterName === 'color') {
      heading = findFilterHeading(drawer, 'colour');
    }

    if (!heading) return null;

    return (
      getControlledPanel(heading) ||
      heading.closest('fieldset') ||
      heading.parentElement
    );
  }

  function getFacetHeadingByName(drawer, filterName) {
    if (!drawer || !filterName) return null;

    var heading = findFilterHeading(drawer, filterName);

    if (!heading && filterName === 'color') {
      heading = findFilterHeading(drawer, 'colour');
    }

    return heading;
  }

  function getFacetContainerByName(drawer, filterName) {
    var heading = getFacetHeadingByName(drawer, filterName);
    if (!heading) return null;

    var knownWrapper = heading.closest(
      'details, fieldset, .collection-sidebar__group, .filter-group, .filter-form__item, .facets__disclosure, .facets__item, .collapsible-content__parent'
    );

    if (knownWrapper && knownWrapper !== drawer) {
      return knownWrapper;
    }

    var panel = getControlledPanel(heading);
    var node = heading.parentElement;

    while (node && node !== drawer) {
      if (!panel || node.contains(panel)) {
        return node;
      }

      node = node.parentElement;
    }

    return heading.parentElement;
  }

  function hideFacetByName(drawer, filterName) {
    var container = getFacetContainerByName(drawer, filterName);
    if (!container) return;

    container.setAttribute('data-ofv-hidden-facet', filterName);
    container.setAttribute('aria-hidden', 'true');
    container.style.setProperty('display', 'none', 'important');
  }

  function getDirectChildUnderAncestor(ancestor, node) {
    if (!ancestor || !node || !ancestor.contains(node)) return null;

    var branch = node;

    while (branch && branch.parentElement !== ancestor) {
      branch = branch.parentElement;
    }

    return branch && branch.parentElement === ancestor ? branch : null;
  }

  function reorderPrimaryFacetContainers(drawer) {
    if (!drawer) return;

    var names = ['size', 'color', 'price'];
    var headings = names.map(function (name) {
      return getFacetHeadingByName(drawer, name);
    });

    var presentHeadings = headings.filter(Boolean);
    if (presentHeadings.length < 2) return;

    var candidate = presentHeadings[0].parentElement;
    var reorderParent = null;
    var branches = null;

    while (candidate && candidate !== drawer.parentElement) {
      var containsAll = presentHeadings.every(function (heading) {
        return candidate.contains(heading);
      });

      if (containsAll) {
        var candidateBranches = presentHeadings.map(function (heading) {
          return getDirectChildUnderAncestor(candidate, heading);
        });

        var allFound = candidateBranches.every(Boolean);
        var unique = candidateBranches.filter(function (branch, index, list) {
          return list.indexOf(branch) === index;
        });

        if (allFound && unique.length === candidateBranches.length) {
          reorderParent = candidate;
          branches = candidateBranches;
          break;
        }
      }

      if (candidate === drawer) break;
      candidate = candidate.parentElement;
    }

    if (!reorderParent || !branches || !branches.length) return;

    names.forEach(function (name) {
      var heading = getFacetHeadingByName(drawer, name);
      if (!heading) return;

      var branch =
        getDirectChildUnderAncestor(
          reorderParent,
          heading
        );

      if (!branch) return;

      branch.setAttribute(
        'data-ofv-primary-facet-branch',
        name
      );
    });

    var children = Array.prototype.slice.call(reorderParent.children);
    var indexes = branches.map(function (branch) {
      return children.indexOf(branch);
    }).filter(function (index) {
      return index >= 0;
    });

    if (!indexes.length) return;

    var earliestIndex = Math.min.apply(Math, indexes);
    var anchor = reorderParent.children[earliestIndex] || null;
    var marker = document.createComment('ofv-primary-facet-order');

    reorderParent.insertBefore(marker, anchor);

    branches.forEach(function (branch) {
      reorderParent.insertBefore(branch, marker);
    });

    if (marker.parentNode) {
      marker.parentNode.removeChild(marker);
    }
  }

  function moveFilterHeaderIntoScrollable(drawer) {
    if (!drawer) return;

    var scrollable = drawer.querySelector('.drawer__scrollable');
    if (!scrollable) return;

    var fixedHeader = drawer.querySelector('.drawer__fixed-header');
    var header = drawer.querySelector('.drawer__header');

    var headerContainer = fixedHeader || header;
    if (!headerContainer) return;

    if (!scrollable.contains(headerContainer)) {
      scrollable.insertBefore(
        headerContainer,
        scrollable.firstChild
      );
    }

    headerContainer.setAttribute(
      'data-ofv-filter-header-scrollable',
      'true'
    );

    if (header && header !== headerContainer) {
      header.setAttribute(
        'data-ofv-filter-header-scrollable',
        'true'
      );
    }

    var headerClose =
      getNativeDrawerHeaderCloseButton(drawer);

    if (
      header &&
      headerClose &&
      !header.contains(headerClose)
    ) {
      header.appendChild(headerClose);
    }
  }

  function syncStickyBarToScrollport(drawer) {
    if (!drawer) return;

    var bar =
      drawer.querySelector(
        '.ofv-drawer-active-filter-bar'
      );

    var scroller =
      getDrawerScroller(drawer);

    if (!bar || !scroller) return;

    var scrollerStyle =
      window.getComputedStyle(scroller);

    var paddingTop =
      parseFloat(
        scrollerStyle.paddingTop
      ) || 0;

    bar.style.setProperty(
      'top',
      (-paddingTop) + 'px',
      'important'
    );

    drawer.style.setProperty(
      '--ofv-sort-sticky-top',
      Math.max(0, bar.offsetHeight - paddingTop) + 'px'
    );
  }

  function getPrimaryFacetArrow(drawer) {
    if (!drawer) return null;

    var trigger =
      getFacetHeadingByName(drawer, 'size') ||
      getFacetHeadingByName(drawer, 'color') ||
      getFacetHeadingByName(drawer, 'price');

    if (!trigger) return null;

    var selectors = [
      '.collapsible-trigger__icon',
      '[class*="collapsible-trigger__icon"]',
      '.icon-chevron-down',
      '.icon-chevron-up',
      '[class*="chevron"]',
      'svg'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var candidates =
        trigger.querySelectorAll(
          selectors[i]
        );

      for (var j = 0; j < candidates.length; j += 1) {
        var candidate =
          candidates[j];

        if (
          !candidate ||
          !candidate.getBoundingClientRect
        ) {
          continue;
        }

        var rect =
          candidate.getBoundingClientRect();

        var style =
          window.getComputedStyle(candidate);

        if (
          rect.width > 2 &&
          rect.height > 2 &&
          style.display !== 'none' &&
          style.visibility !== 'hidden'
        ) {
          return candidate;
        }
      }
    }

    return null;
  }

  function alignFilterHeaderCloseWithFacetArrow(drawer) {
    if (!drawer) return;

    var closeButton =
      getNativeDrawerHeaderCloseButton(drawer);

    if (!closeButton) return;

    closeButton.style.setProperty(
      'position',
      'static',
      'important'
    );

    closeButton.style.setProperty(
      'top',
      'auto',
      'important'
    );

    closeButton.style.setProperty(
      'right',
      'auto',
      'important'
    );

    closeButton.style.setProperty(
      'bottom',
      'auto',
      'important'
    );

    closeButton.style.setProperty(
      'left',
      'auto',
      'important'
    );

    closeButton.style.setProperty(
      'transform',
      'none',
      'important'
    );

    closeButton.style.setProperty(
      'margin',
      '0',
      'important'
    );
  }

  function integrateDrawerSortWithPrimaryFacets(drawer) {
    if (!drawer) return;

    var sortSection = drawer.querySelector('.ofv-drawer-sort-section');
    if (!sortSection) return;

    var firstBranch =
      drawer.querySelector('[data-ofv-primary-facet-branch="size"]') ||
      drawer.querySelector('[data-ofv-primary-facet-branch="color"]') ||
      drawer.querySelector('[data-ofv-primary-facet-branch="price"]');

    if (!firstBranch || !firstBranch.parentElement) return;

    var stack = firstBranch.parentElement;

    if (sortSection.parentElement !== stack || sortSection.nextElementSibling !== firstBranch) {
      stack.insertBefore(sortSection, firstBranch);
    }
  }

  function normalizePrimaryFacetBranchGeometry(drawer) {
    if (!drawer) return;

    var branches =
      Array.prototype.slice.call(
        drawer.querySelectorAll(
          '[data-ofv-primary-facet-branch="size"], ' +
          '[data-ofv-primary-facet-branch="color"], ' +
          '[data-ofv-primary-facet-branch="price"]'
        )
      );

    if (!branches.length) return;

    branches.forEach(function (branch) {
      branch.style.setProperty(
        'width',
        '100%',
        'important'
      );

      branch.style.setProperty(
        'max-width',
        '100%',
        'important'
      );

      branch.style.setProperty(
        'min-width',
        '0',
        'important'
      );

      branch.style.setProperty(
        'margin-left',
        '0',
        'important'
      );

      branch.style.setProperty(
        'margin-right',
        '0',
        'important'
      );

      branch.style.setProperty(
        'padding-left',
        '0',
        'important'
      );

      branch.style.setProperty(
        'padding-right',
        '0',
        'important'
      );

      branch.style.setProperty(
        'box-sizing',
        'border-box',
        'important'
      );
    });
  }

  function syncPrimaryFacetClosedGeometry(drawer) {
    if (!drawer) return;

    ['size', 'color', 'price'].forEach(function (filterName) {
      var trigger =
        getFacetHeadingByName(
          drawer,
          filterName
        );

      var branch =
        drawer.querySelector(
          '[data-ofv-primary-facet-branch="' +
          filterName +
          '"]'
        );

      if (!trigger || !branch) return;

      var isOpen =
        isAccordionOpen(trigger);

      if (isOpen) {
        branch.removeAttribute(
          'data-ofv-primary-facet-closed'
        );

        branch.style.removeProperty('height');
        branch.style.removeProperty('min-height');
        branch.style.removeProperty('max-height');
        branch.style.removeProperty('overflow');
      } else {
        branch.setAttribute(
          'data-ofv-primary-facet-closed',
          'true'
        );

        branch.style.setProperty(
          'height',
          '56px',
          'important'
        );

        branch.style.setProperty(
          'min-height',
          '56px',
          'important'
        );

        branch.style.setProperty(
          'max-height',
          '56px',
          'important'
        );

        branch.style.setProperty(
          'overflow',
          'hidden',
          'important'
        );
      }

      if (!trigger.__ofvClosedFacetGeometryBound) {
        trigger.__ofvClosedFacetGeometryBound = true;

        trigger.addEventListener(
          'click',
          function () {
            window.setTimeout(function () {
              syncPrimaryFacetClosedGeometry(
                getDrawer() || drawer
              );
            }, 0);

            window.setTimeout(function () {
              syncPrimaryFacetClosedGeometry(
                getDrawer() || drawer
              );
            }, 180);
          }
        );
      }
    });
  }

  function prepareDrawerFacetPresentation(drawer) {
    if (!drawer) return;

    moveFilterHeaderIntoScrollable(drawer);

    hideFacetByName(drawer, 'availability');
    hideFacetByName(drawer, 'product type');

    reorderPrimaryFacetContainers(drawer);
    integrateDrawerSortWithPrimaryFacets(drawer);
    normalizePrimaryFacetBranchGeometry(drawer);

    ['size', 'color', 'price'].forEach(function (filterName) {
      var trigger = getFacetHeadingByName(drawer, filterName);
      var container = getFacetContainerByName(drawer, filterName);

      if (trigger) {
        trigger.classList.add('ofv-primary-facet-trigger');
        trigger.setAttribute('data-ofv-primary-facet-trigger', filterName);
      }

      if (container && container !== drawer) {
        container.setAttribute('data-ofv-primary-facet', filterName);
      }
    });

    syncPrimaryFacetClosedGeometry(
      drawer
    );

    window.requestAnimationFrame(function () {
      syncPrimaryFacetClosedGeometry(
        getDrawer() || drawer
      );
    });

    alignFilterHeaderCloseWithFacetArrow(
      drawer
    );

    window.requestAnimationFrame(
      function () {
        alignFilterHeaderCloseWithFacetArrow(
          getDrawer() || drawer
        );
      }
    );
  }

  function removeTrailingCountFromTextNode(textNode) {
    if (!textNode || typeof textNode.nodeValue !== 'string') return;

    var original = textNode.nodeValue;

    var cleaned = original.replace(/\s*\(\s*\d+\s*\)\s*$/, '');

    if (cleaned !== original) {
      textNode.nodeValue = cleaned;
    }
  }

  function removeFacetOptionCountsFromRoot(root) {
    if (!root) return;

    root.setAttribute('data-ofv-option-counts-hidden', 'true');

    var inputs = root.querySelectorAll(
      'input[type="checkbox"][name^="filter."], input[type="radio"][name^="filter."]'
    );

    Array.prototype.forEach.call(inputs, function (input) {
      var row = getFilterOptionRow(input, root);
      if (!row) return;

      var candidates = row.querySelectorAll(
        'span, small, em, strong, div'
      );

      Array.prototype.forEach.call(candidates, function (node) {
        if (!node || node === row || node.contains(input)) return;

        var text = (node.textContent || '')
          .replace(/\s+/g, ' ')
          .trim();

        if (/^\(\s*\d+\s*\)$/.test(text)) {
          node.setAttribute('data-ofv-facet-count-hidden', 'true');
          node.style.setProperty('display', 'none', 'important');
        }
      });

      var walker = document.createTreeWalker(
        row,
        window.NodeFilter ? window.NodeFilter.SHOW_TEXT : 4,
        null
      );

      var textNodes = [];
      var currentNode;

      while ((currentNode = walker.nextNode())) {
        textNodes.push(currentNode);
      }

      textNodes.forEach(removeTrailingCountFromTextNode);
    });
  }

  function removeSelectedFacetOptionCounts(drawer) {
    if (!drawer) return;

    [
      'size',
      'color',
      'product type',
      'availability'
    ].forEach(function (filterName) {
      removeFacetOptionCountsFromRoot(
        getFacetRootByName(drawer, filterName)
      );
    });
  }

  function facetInputIsZeroResult(input, root) {
    if (!input) return false;
    if (input.checked) return false;

    var row = getFilterOptionRow(input, root);
    if (!row) return false;

    if (row.getAttribute('data-ofv-zero-result-source') === 'true') {
      return true;
    }

    var label = getInputLabelElement(input, root);

    var explicitlyDisabled =
      input.disabled ||
      input.getAttribute('aria-disabled') === 'true' ||
      row.getAttribute('aria-disabled') === 'true' ||
      (label && label.getAttribute('aria-disabled') === 'true') ||
      row.classList.contains('disabled') ||
      row.classList.contains('is-disabled') ||
      (label && (
        label.classList.contains('disabled') ||
        label.classList.contains('is-disabled')
      ));

    if (explicitlyDisabled) {
      row.setAttribute('data-ofv-zero-result-source', 'true');
      return true;
    }

    var rowText = (row.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();

    if (/\(\s*0\s*\)\s*$/.test(rowText)) {
      row.setAttribute('data-ofv-zero-result-source', 'true');
      return true;
    }

    var countCandidates = row.querySelectorAll(
      '[class*="count"], [data-count], [data-filter-count]'
    );

    for (var i = 0; i < countCandidates.length; i += 1) {
      var candidate = countCandidates[i];
      var rawCount =
        candidate.getAttribute('data-count') ||
        candidate.getAttribute('data-filter-count') ||
        candidate.textContent ||
        '';

      var match = String(rawCount).match(/(?:^|\()\s*(\d+)\s*\)?$/);

      if (match && parseInt(match[1], 10) === 0) {
        row.setAttribute('data-ofv-zero-result-source', 'true');
        return true;
      }
    }

    return false;
  }

  function setGroupedZeroResultVisibility(root, inputs, keyGetter) {
    if (!root || !inputs || !inputs.length) return;

    var groups = {};

    inputs.forEach(function (input) {
      var key = keyGetter(input);
      if (!key) return;

      if (!groups[key]) groups[key] = [];
      groups[key].push(input);
    });

    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      var primary =
        group.find(function (input) {
          var row = getFilterOptionRow(input, root);
          return row &&
            !row.hasAttribute('data-ofv-case-duplicate-hidden') &&
            !row.hasAttribute('data-ofv-size-duplicate-hidden');
        }) || group[0];

      if (!primary) return;

      var primaryRow = getFilterOptionRow(primary, root);
      if (!primaryRow) return;

      var anyChecked = group.some(function (input) {
        return input.checked;
      });

      var anyAvailable = group.some(function (input) {
        return !facetInputIsZeroResult(input, root);
      });

      if (!anyChecked && !anyAvailable) {
        primaryRow.setAttribute('data-ofv-zero-result-hidden', 'true');
        primaryRow.setAttribute('aria-hidden', 'true');
        primaryRow.style.setProperty('display', 'none', 'important');
      } else {
        primaryRow.removeAttribute('data-ofv-zero-result-hidden');

        if (
          !primaryRow.hasAttribute('data-ofv-case-duplicate-hidden') &&
          !primaryRow.hasAttribute('data-ofv-size-duplicate-hidden')
        ) {
          primaryRow.style.removeProperty('display');
          primaryRow.removeAttribute('aria-hidden');
        }
      }
    });
  }

 function setEmptyFacetVisibility(
  drawer,
  filterName,
  root,
  inputs
) {
  if (
    !drawer ||
    !root
  ) {
    return;
  }

  inputs =
    inputs || [];

  var hasActiveSelection =
    inputs.some(
      function (input) {
        return !!input.checked;
      }
    );

  var hasAvailableOption =
    inputs.some(
      function (input) {
        return !facetInputIsZeroResult(
          input,
          root
        );
      }
    );

  var shouldHide =
    !hasActiveSelection &&
    !hasAvailableOption;

  var container =
    getFacetContainerByName(
      drawer,
      filterName
    );

  if (container) {

    if (shouldHide) {

      container.setAttribute(
        'data-ofv-empty-facet-hidden',
        'true'
      );

      container.setAttribute(
        'aria-hidden',
        'true'
      );

      container.style.setProperty(
        'display',
        'none',
        'important'
      );

    } else if (
      container.getAttribute(
        'data-ofv-empty-facet-hidden'
      ) === 'true'
    ) {

      container.removeAttribute(
        'data-ofv-empty-facet-hidden'
      );

      container.removeAttribute(
        'aria-hidden'
      );

      container.style.removeProperty(
        'display'
      );
    }
  }

  var shortcutSelector =
    filterName === 'size'
      ? '.ofv-toolbar-size-shortcut-wrap'
      : '.ofv-toolbar-color-shortcut-wrap';

  document
    .querySelectorAll(
      shortcutSelector
    )
    .forEach(
      function (shortcut) {

        if (shouldHide) {

          shortcut.setAttribute(
            'data-ofv-empty-facet-hidden',
            'true'
          );

          shortcut.style.setProperty(
            'display',
            'none',
            'important'
          );

        } else if (
          shortcut.getAttribute(
            'data-ofv-empty-facet-hidden'
          ) === 'true'
        ) {

          shortcut.removeAttribute(
            'data-ofv-empty-facet-hidden'
          );

          shortcut.style.removeProperty(
            'display'
          );
        }
      }
    );
}

function hideZeroResultFilterOptions(drawer) {
  if (!drawer) return;

  var colorRoot =
    getColorFilterRoot(drawer);

  var sizeRoot =
    getSizeFilterRoot(drawer);

  var colorInputs =
    getColorCheckboxes(drawer);

  var sizeInputs =
    getSizeCheckboxes(drawer);

  if (colorRoot) {

    setGroupedZeroResultVisibility(
      colorRoot,
      colorInputs,
      function (input) {
        return getCanonicalColorInfo(
          input.value
        ).key;
      }
    );

    setEmptyFacetVisibility(
      drawer,
      'color',
      colorRoot,
      colorInputs
    );
  }

  if (sizeRoot) {

    setGroupedZeroResultVisibility(
      sizeRoot,
      sizeInputs,
      function (input) {
        return getCanonicalSizeInfo(
          input.value
        ).key;
      }
    );

    setEmptyFacetVisibility(
      drawer,
      'size',
      sizeRoot,
      sizeInputs
    );
  }
}

  function getCanonicalSizeInfo(value) {
    var original = String(value || '').replace(/\s+/g, ' ').trim();

    var normalized = normalizeCaseInsensitiveValue(original)
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s*-\s*/g, '-');

    var key = '';
    var label = '';

    switch (normalized) {
      case 'xs':
      case 'x-small':
      case 'x small':
      case 'xsmall':
      case 'extra small':
        key = 'xs';
        label = 'XS';
        break;

      case 's':
      case 'small':
        key = 's';
        label = 'S';
        break;

      case 'm':
      case 'medium':
        key = 'm';
        label = 'M';
        break;

      case 'l':
      case 'large':
        key = 'l';
        label = 'L';
        break;

      case 'xl':
      case 'x-large':
      case 'x large':
      case 'xlarge':
      case 'extra large':
        key = 'xl';
        label = 'XL';
        break;

      case 'xxl':
      case 'xx-large':
      case 'xx large':
      case 'xxlarge':
      case '2xl':
        key = 'xxl';
        label = 'XXL';
        break;

      case 'xxxl':
      case 'xxx-large':
      case 'xxx large':
      case 'xxxlarge':
      case '3xl':
        key = 'xxxl';
        label = 'XXXL';
        break;

      case 's/m':
      case 's-m':
      case 'sm':
      case 'small/medium':
      case 'small-medium':
      case 'small medium':
        key = 's/m';
        label = 'S/M';
        break;

      case 'm/l':
      case 'm-l':
      case 'ml':
      case 'medium/large':
      case 'medium-large':
      case 'medium large':
        key = 'm/l';
        label = 'M/L';
        break;

      case 'l/xl':
      case 'l-xl':
      case 'lxl':
      case 'large/xl':
      case 'large/x-large':
      case 'large/extra large':
      case 'large-extra large':
        key = 'l/xl';
        label = 'L/XL';
        break;

      case 'o/s':
      case 'o-s':
      case 'os':
      case 'one size':
      case 'one-size':
      case 'onesize':
      case 'one size fits all':
      case 'osfa':
        key = 'o/s';
        label = 'O/S';
        break;

      case 'plus':
      case 'plus size':
      case 'plus-size':
      case 'plus sizes':
        key = 'plus';
        label = 'PLUS';
        break;

      case '1x':
        key = '1x';
        label = '1X';
        break;

      case '2x':
        key = '2x';
        label = '2X';
        break;

      case '3x':
        key = '3x';
        label = '3X';
        break;

      default:

        key = 'raw:' + normalized;
        label = original;
        break;
    }

    return {
      key: key,
      label: label || original
    };
  }

  function getInputLabelElement(input, root) {
    if (!input) return null;

    var wrappedLabel = input.closest('label');
    if (wrappedLabel) return wrappedLabel;

    if (input.id && root) {
      var labels = root.querySelectorAll('label[for]');

      for (var i = 0; i < labels.length; i += 1) {
        if (labels[i].htmlFor === input.id) {
          return labels[i];
        }
      }
    }

    var row = getFilterOptionRow(input, root);
    if (!row) return null;

    return row.querySelector('label') || row;
  }

  function setColorOptionVisibleLabel(input, root, canonicalLabel) {
    if (!input || !root || !canonicalLabel) return;

    var labelElement = getInputLabelElement(input, root);
    if (!labelElement) return;

    var targetKey = getCanonicalColorInfo(input.value).key;
    var walker = document.createTreeWalker(
      labelElement,
      window.NodeFilter ? window.NodeFilter.SHOW_TEXT : 4,
      null
    );

    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    for (var i = 0; i < nodes.length; i += 1) {
      var raw = nodes[i].nodeValue || '';
      var withoutCount = raw.replace(/\s*\(\s*\d+\s*\)\s*$/, '');
      var candidate = withoutCount.replace(/\s+/g, ' ').trim();

      if (!candidate) continue;
      if (getCanonicalColorInfo(candidate).key !== targetKey) continue;

      var leading = (raw.match(/^\s*/) || [''])[0];
      var trailing = (raw.match(/\s*$/) || [''])[0];

      nodes[i].nodeValue = leading + canonicalLabel + trailing;
      break;
    }
  }

  function getColorSortRank(info) {
    var ranks = {
      'black': 10,
      'white': 20,
      'offwhite': 21,
      'ivory': 22,
      'cream': 23,

      'natural': 30,
      'nude': 31,
      'beige': 32,
      'sand': 32.5,
      'fango': 33,
      'taupe': 34,
      'camel': 35,
      'tan': 36,
      'khaki': 37,

      'brown': 40,
      'chocolate': 41,
      'cinnamon': 42,
      'maroonbrown': 43,

      'grey': 50,
      'gray': 51,
      'charcoal': 52,

      'navy': 60,
      'inknavy': 60.5,
      'blue': 61,
      'denimblue': 62,
      'denim': 62.25,
      'jeans': 62.5,
      'royalblue': 63,
      'cobalt': 63.5,
      'skyblue': 64,
      'powderblue': 65,
      'celeste': 66,
      'periwinkle': 67,

      'lightwash': 68,
      'midwash': 69,
      'darkwash': 70,

      'teal': 75,
      'turquoise': 76,
      'aqua': 77,

      'green': 80,
      'mint': 80.5,
      'sage': 81,
      'moss': 82,
      'olive': 83,
      'military': 84,
      'militarygreen': 85,
      'forestgreen': 86,
      'biscaygreen': 87,
      'kellygreen': 88,
      'lime': 89,
      'polarpear': 89.5,

      'pink': 90,
      'newpink': 90.5,
      'petal': 90.75,
      'dustypink': 91,
      'fuchsia': 92,
      'magenta': 93,
      'raspberry': 93.5,
      'coral': 94,
      'peach': 95,

      'purple': 100,
      'lilac': 101,
      'newpurple': 102,

      'red': 110,
      'persianred': 110.25,
      'ruby': 110.5,
      'wine': 111,
      'burgundy': 112,
      'maroon': 113,

      'orange': 120,
      'burntorange': 121,
      'mango': 122,
      'butteryellow': 129,
      'yellow': 130,
      'gold': 140,
      'silver': 141
    };

    if (
      info &&
      Object.prototype.hasOwnProperty.call(ranks, info.key)
    ) {
      return ranks[info.key];
    }

    return 1000;
  }

  function reorderColorFilterRows(root, groups) {
    if (!root || !groups) return;

    var items = [];

    Object.keys(groups).forEach(function (key) {
      var groupData = groups[key];
      var primary = groupData.primary || groupData.inputs[0];
      if (!primary) return;

      var row = getFilterOptionRow(primary, root);
      if (!row || !row.parentElement) return;

      items.push({
        row: row,
        parent: row.parentElement,
        rank: getColorSortRank(groupData.info),
        label: normalizeCaseInsensitiveValue(
          (groupData.info && groupData.info.label) || primary.value
        )
      });
    });

    var parentGroups = [];

    items.forEach(function (item) {
      var existing = parentGroups.find(function (group) {
        return group.parent === item.parent;
      });

      if (!existing) {
        existing = {
          parent: item.parent,
          items: []
        };
        parentGroups.push(existing);
      }

      existing.items.push(item);
    });

    parentGroups.forEach(function (group) {
      if (group.items.length < 2) return;

      var parentChildren = Array.prototype.slice.call(group.parent.children);
      var originalIndexes = group.items.map(function (item) {
        return parentChildren.indexOf(item.row);
      }).filter(function (index) {
        return index >= 0;
      });

      if (!originalIndexes.length) return;

      var earliestIndex = Math.min.apply(Math, originalIndexes);
      var anchor = group.parent.children[earliestIndex] || null;
      var marker = document.createComment('ofv-color-order');

      group.parent.insertBefore(marker, anchor);

      group.items.sort(function (a, b) {
        if (a.rank !== b.rank) return a.rank - b.rank;
        return a.label.localeCompare(b.label);
      });

      group.items.forEach(function (item) {
        group.parent.insertBefore(item.row, marker);
      });

      if (marker.parentNode) {
        marker.parentNode.removeChild(marker);
      }
    });
  }

  function setSizeOptionVisibleLabel(input, root, canonicalLabel) {
    if (!input || !root || !canonicalLabel) return;

    var labelElement = getInputLabelElement(input, root);
    if (!labelElement) return;

    var targetKey = getCanonicalSizeInfo(input.value).key;
    var walker = document.createTreeWalker(
      labelElement,
      window.NodeFilter ? window.NodeFilter.SHOW_TEXT : 4,
      null
    );

    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    for (var i = 0; i < nodes.length; i += 1) {
      var raw = nodes[i].nodeValue || '';
      var withoutCount = raw.replace(/\s*\(\s*\d+\s*\)\s*$/, '');
      var candidate = withoutCount.replace(/\s+/g, ' ').trim();

      if (!candidate) continue;

      if (getCanonicalSizeInfo(candidate).key !== targetKey) continue;

      var leading = (raw.match(/^\s*/) || [''])[0];
      var trailing = (raw.match(/\s*$/) || [''])[0];

      nodes[i].nodeValue = leading + canonicalLabel + trailing;
      break;
    }
  }

  function getSizeSortRank(info) {
    var ranks = {

      's/m': 10,
      'm/l': 20,
      'l/xl': 30,
      'o/s': 40,

      'xs': 50,
      's': 60,
      'm': 70,
      'l': 80,
      'xl': 90,
      'xxl': 100,
      'xxxl': 110,

      'plus': 120,
      '1x': 130,
      '2x': 140,
      '3x': 150
    };

    if (
      info &&
      Object.prototype.hasOwnProperty.call(ranks, info.key)
    ) {
      return ranks[info.key];
    }

    return 1000;
  }

  function reorderSizeFilterRows(root, groups) {
    if (!root || !groups) return;

    var items = [];

    Object.keys(groups).forEach(function (key) {
      var groupData = groups[key];
      var primary = groupData.primary || groupData.inputs[0];

      if (!primary) return;

      var row = getFilterOptionRow(primary, root);
      if (!row || !row.parentElement) return;

      items.push({
        row: row,
        parent: row.parentElement,
        info: groupData.info,
        rank: getSizeSortRank(groupData.info)
      });
    });

    var parentGroups = [];

    items.forEach(function (item) {
      var existing = parentGroups.find(function (group) {
        return group.parent === item.parent;
      });

      if (!existing) {
        existing = {
          parent: item.parent,
          items: []
        };
        parentGroups.push(existing);
      }

      existing.items.push(item);
    });

    parentGroups.forEach(function (group) {
      if (group.items.length < 2) return;

      var parentChildren = Array.prototype.slice.call(group.parent.children);
      var originalIndexes = group.items.map(function (item) {
        return parentChildren.indexOf(item.row);
      }).filter(function (index) {
        return index >= 0;
      });

      if (!originalIndexes.length) return;

      var earliestIndex = Math.min.apply(Math, originalIndexes);
      var anchor = group.parent.children[earliestIndex] || null;
      var marker = document.createComment('ofv-size-order');

      group.parent.insertBefore(marker, anchor);

      group.items.sort(function (a, b) {
        if (a.rank !== b.rank) return a.rank - b.rank;

        return String(a.info.label || '').localeCompare(
          String(b.info.label || ''),
          undefined,
          { sensitivity: 'base' }
        );
      });

      group.items.forEach(function (item) {
        group.parent.insertBefore(item.row, marker);
      });

      if (marker.parentNode) {
        marker.parentNode.removeChild(marker);
      }
    });
  }

  function getCaseInsensitiveColorGroup(drawer, value) {
    var key = getCanonicalColorInfo(value).key;

    return getColorCheckboxes(drawer).filter(function (input) {
      return getCanonicalColorInfo(input.value).key === key;
    });
  }

  function getGroupedSizeInputs(drawer, value) {
    var targetInfo = getCanonicalSizeInfo(value);

    return getSizeCheckboxes(drawer).filter(function (input) {
      return getCanonicalSizeInfo(input.value).key === targetInfo.key;
    });
  }

  function ensureCaseInsensitiveColorGroups(drawer) {
    if (!drawer) return;

    var root = getColorFilterRoot(drawer);
    if (!root) return;

    var inputs = getColorCheckboxes(drawer);
    var groups = {};

    inputs.forEach(function (input) {
      var info = getCanonicalColorInfo(input.value);
      var key = info.key;

      if (!key) return;

      if (!groups[key]) {
        groups[key] = {
          info: info,
          inputs: []
        };
      }

      groups[key].inputs.push(input);
    });

    Object.keys(groups).forEach(function (key) {
      var groupData = groups[key];
      var group = groupData.inputs;
      var info = groupData.info;

      if (!group.length) return;

      var primary =
        group.find(function (input) { return input.checked; }) ||
        group[0];

      var anyChecked = group.some(function (input) {
        return input.checked;
      });

      groupData.primary = primary;

      group.forEach(function (input) {
        input.setAttribute('data-ofv-case-color-group', key);
        input.setAttribute('data-ofv-color-label', info.label);
        input.checked = anyChecked;
      });

      setColorOptionVisibleLabel(primary, root, info.label);
      ensureColorOptionSwatch(primary, root, info.label);

      if (group.length > 1) {
        group.forEach(function (input) {
          var row = getFilterOptionRow(input, root);
          if (!row) return;

          if (input === primary) {
            row.removeAttribute('data-ofv-case-duplicate-hidden');
            row.style.removeProperty('display');
            row.removeAttribute('aria-hidden');
          } else {
            row.setAttribute('data-ofv-case-duplicate-hidden', 'true');
            row.style.setProperty('display', 'none', 'important');
            row.setAttribute('aria-hidden', 'true');
          }
        });
      }
    });

    reorderColorFilterRows(root, groups);

    if (!root.__ofvCaseInsensitiveColorClickBound) {
      root.__ofvCaseInsensitiveColorClickBound = true;

      root.addEventListener(
        'click',
        function (event) {
          var input = event.target.closest
            ? event.target.closest('input[type="checkbox"][data-ofv-case-color-group]')
            : null;

          if (!input) return;

          var group = getCaseInsensitiveColorGroup(drawer, input.value);

          group.forEach(function (groupInput) {
            groupInput.checked = input.checked;
          });
        },
        true
      );
    }
  }

  function ensureGroupedSizeFilters(drawer) {
    if (!drawer) return;

    var root = getSizeFilterRoot(drawer);
    if (!root) return;

    var inputs = getSizeCheckboxes(drawer);
    var groups = {};

    inputs.forEach(function (input) {
      var info = getCanonicalSizeInfo(input.value);
      if (!info.key) return;

      if (!groups[info.key]) {
        groups[info.key] = {
          info: info,
          inputs: []
        };
      }

      groups[info.key].inputs.push(input);
    });

    Object.keys(groups).forEach(function (key) {
      var groupData = groups[key];
      var group = groupData.inputs;
      var info = groupData.info;

      if (!group.length) return;

      var preferredLabel =
        normalizeCaseInsensitiveValue(info.label);

      var primary =
        group.find(function (input) {
          return normalizeCaseInsensitiveValue(input.value) === preferredLabel;
        }) ||
        group.find(function (input) {
          return input.checked;
        }) ||
        group[0];

      var anyChecked = group.some(function (input) {
        return input.checked;
      });

      groupData.primary = primary;

      group.forEach(function (input) {
        input.setAttribute('data-ofv-size-group', key);
        input.setAttribute('data-ofv-size-label', info.label);
        input.checked = anyChecked;
      });

      setSizeOptionVisibleLabel(primary, root, info.label);

      if (group.length > 1) {
        group.forEach(function (input) {
          var row = getFilterOptionRow(input, root);
          if (!row) return;

          if (input === primary) {
            row.removeAttribute('data-ofv-size-duplicate-hidden');
            row.style.removeProperty('display');
            row.removeAttribute('aria-hidden');
          } else {
            row.setAttribute('data-ofv-size-duplicate-hidden', 'true');
            row.style.setProperty('display', 'none', 'important');
            row.setAttribute('aria-hidden', 'true');
          }
        });
      }
    });

    reorderSizeFilterRows(root, groups);

    if (!root.__ofvGroupedSizeClickBound) {
      root.__ofvGroupedSizeClickBound = true;

      root.addEventListener(
        'click',
        function (event) {
          var input = event.target.closest
            ? event.target.closest('input[type="checkbox"][data-ofv-size-group]')
            : null;

          if (!input) return;

          var group = getGroupedSizeInputs(drawer, input.value);

          group.forEach(function (groupInput) {
            groupInput.checked = input.checked;
          });
        },
        true
      );
    }
  }

  function getGroupedColorInputsFromActiveItem(item) {
    if (!item) return [];

    var filterName = item.getAttribute('data-ofv-filter-name') || '';
    var value =
      item.getAttribute('data-ofv-filter-value') ||
      item.getAttribute('data-ofv-active-label') ||
      '';

    if (!isColorFilterName(filterName)) return [];

    return getCaseInsensitiveColorGroup(getDrawer(), value);
  }

  function getGroupedSizeInputsFromActiveItem(item) {
    if (!item) return [];

    var filterName = item.getAttribute('data-ofv-filter-name') || '';
    var value =
      item.getAttribute('data-ofv-filter-value') ||
      item.getAttribute('data-ofv-active-label') ||
      '';

    if (!isSizeFilterName(filterName)) return [];

    return getGroupedSizeInputs(getDrawer(), value);
  }

  function applyGroupedColorRemoval(item) {
    var inputs = getGroupedColorInputsFromActiveItem(item);

    if (inputs.length < 2) return false;

    var drawer = getDrawer();

    inputs.forEach(function (input) {
      input.checked = false;
    });

    var triggerInput = inputs[0];

    if (drawer && isDrawerReady(drawer)) {
      showFilterLoadingSkeleton();
      captureDrawerStateIfNeeded();
    }

    triggerInput.dispatchEvent(
      new Event('change', {
        bubbles: true,
        cancelable: true
      })
    );

    return true;
  }

  function applyGroupedSizeRemoval(item) {
    var inputs = getGroupedSizeInputsFromActiveItem(item);

    if (inputs.length < 2) return false;

    var drawer = getDrawer();

    inputs.forEach(function (input) {
      input.checked = false;
    });

    var triggerInput = inputs[0];

    if (drawer && isDrawerReady(drawer)) {
      showFilterLoadingSkeleton();
      captureDrawerStateIfNeeded();
    }

    triggerInput.dispatchEvent(
      new Event('change', {
        bubbles: true,
        cancelable: true
      })
    );

    return true;
  }

  function consolidateToolbarCaseInsensitiveColorChips() {
    var wrappers = document.querySelectorAll(
      '.ofv-toolbar-active-filters'
    );

    wrappers.forEach(function (wrapper) {
      var chips = Array.prototype.slice.call(
        wrapper.querySelectorAll('.ofv-active-filter')
      );

      var groups = {};

      chips.forEach(function (chip) {
        var filterName = chip.getAttribute('data-ofv-filter-name') || '';
        var filterValue = chip.getAttribute('data-ofv-filter-value') || '';

        if (!isColorFilterName(filterName) || !filterValue) return;

        var info = getCanonicalColorInfo(filterValue);
        var key =
          normalizeCaseInsensitiveValue(filterName) +
          '||' +
          info.key;

        if (!groups[key]) {
          groups[key] = {
            info: info,
            chips: []
          };
        }

        groups[key].chips.push(chip);
      });

      Object.keys(groups).forEach(function (key) {
        var groupData = groups[key];
        var group = groupData.chips;
        var info = groupData.info;

        if (!group.length) return;

        var primary = group[0];
        var primaryLabel =
          primary.querySelector('.ofv-active-filter__label');

        if (primaryLabel && info.label) {
          primaryLabel.textContent = info.label;
        }

        primary.setAttribute(
          'aria-label',
          'Remove ' + (info.label || primary.textContent.trim()) + ' filter'
        );

        group.forEach(function (chip) {
          if (chip === primary) {
            chip.style.removeProperty('display');
            chip.removeAttribute('aria-hidden');
            return;
          }

          chip.style.setProperty('display', 'none', 'important');
          chip.setAttribute('aria-hidden', 'true');
        });

        if (
          group.length > 1 &&
          !primary.__ofvGroupedColorRemovalBound
        ) {
          primary.__ofvGroupedColorRemovalBound = true;

          primary.addEventListener('click', function (event) {
            if (!applyGroupedColorRemoval(primary)) return;

            event.preventDefault();
            event.stopPropagation();
          });
        }
      });
    });
  }

  function consolidateToolbarGroupedSizeChips() {
    var wrappers = document.querySelectorAll(
      '.ofv-toolbar-active-filters'
    );

    wrappers.forEach(function (wrapper) {
      var chips = Array.prototype.slice.call(
        wrapper.querySelectorAll('.ofv-active-filter')
      );

      var groups = {};

      chips.forEach(function (chip) {
        var filterName = chip.getAttribute('data-ofv-filter-name') || '';
        var filterValue = chip.getAttribute('data-ofv-filter-value') || '';

        if (!isSizeFilterName(filterName) || !filterValue) return;

        var info = getCanonicalSizeInfo(filterValue);
        var key =
          normalizeCaseInsensitiveValue(filterName) +
          '||' +
          info.key;

        if (!groups[key]) {
          groups[key] = {
            info: info,
            chips: []
          };
        }

        groups[key].chips.push(chip);
      });

      Object.keys(groups).forEach(function (key) {
        var groupData = groups[key];
        var group = groupData.chips;
        var info = groupData.info;

        if (!group.length) return;

        var preferredLabel =
          normalizeCaseInsensitiveValue(info.label);

        var primary =
          group.find(function (chip) {
            return normalizeCaseInsensitiveValue(
              chip.getAttribute('data-ofv-filter-value') || ''
            ) === preferredLabel;
          }) ||
          group[0];

        var primaryLabel =
          primary.querySelector('.ofv-active-filter__label');

        if (primaryLabel && info.label) {
          primaryLabel.textContent = info.label;
        }

        primary.setAttribute(
          'aria-label',
          'Remove ' + (info.label || primary.textContent.trim()) + ' filter'
        );

        group.forEach(function (chip) {
          if (chip === primary) {
            chip.style.removeProperty('display');
            chip.removeAttribute('aria-hidden');
            return;
          }

          chip.style.setProperty('display', 'none', 'important');
          chip.setAttribute('aria-hidden', 'true');
        });

        if (
          group.length > 1 &&
          !primary.__ofvGroupedSizeRemovalBound
        ) {
          primary.__ofvGroupedSizeRemovalBound = true;

          primary.addEventListener('click', function (event) {
            if (!applyGroupedSizeRemoval(primary)) return;

            event.preventDefault();
            event.stopPropagation();
          });
        }
      });
    });
  }

  function updateToolbarGroupedFilterCount() {
    var toolbars = document.querySelectorAll('.ofv-collection-toolbar');

    toolbars.forEach(function (toolbar) {
      var wrapper = toolbar.querySelector('.ofv-toolbar-active-filters');
      var countNode = toolbar.querySelector(
        '.ofv-toolbar-all-filters .ofv-toolbar-control__count'
      );

      if (!wrapper || !countNode) return;

      var chips = Array.prototype.slice.call(
        wrapper.querySelectorAll(
          '.ofv-active-filter:not(.ofv-active-filter--clear)'
        )
      );

      var visibleCount = chips.filter(function (chip) {
        return chip.getAttribute('aria-hidden') !== 'true' &&
          chip.style.display !== 'none';
      }).length;

      countNode.textContent = '(' + visibleCount + ')';
    });
  }

  function consolidateToolbarGroupedFilterChips() {
    consolidateToolbarCaseInsensitiveColorChips();
    consolidateToolbarGroupedSizeChips();
    updateToolbarGroupedFilterCount();
  }

  function getCurrentGrid() {
    return document.querySelector(
      '.ofv-collection-grid[data-ofv-result-count]'
    );
  }

  function getCurrentCount() {
    var grid = getCurrentGrid();
    if (!grid) return null;

    var value = parseInt(
      grid.getAttribute('data-ofv-result-count'),
      10
    );

    return Number.isFinite(value) ? value : null;
  }

 function getClearFiltersUrl() {
  var grid = getCurrentGrid();

  if (grid) {
    var gridUrl =
      grid.getAttribute(
        'data-ofv-clear-filters-url'
      );

    if (gridUrl) {
      return gridUrl;
    }
  }

  var clearLink =
    document.querySelector(
      '.ofv-active-filter-source__item--clear[data-ofv-clear-filters], ' +
      '.ofv-active-filter--clear'
    );

  if (
    clearLink &&
    clearLink.getAttribute('href')
  ) {
    return clearLink.getAttribute('href');
  }

  return '';
}

function setViewButtonCount(button, count) {
  if (!button) return;

  var wrapper =
    button.closest(
      '.ofv-filter-apply'
    );

  var message =
    wrapper
      ? wrapper.querySelector(
          '.ofv-filter-zero-message'
        )
      : null;

  var isZero =
    Number.isFinite(count) &&
    count === 0;

  if (isZero) {

    button.textContent =
      'Clear Filters';

    button.setAttribute(
      'data-ofv-filter-button-mode',
      'clear'
    );

    button.setAttribute(
      'aria-label',
      'Clear all filters'
    );

    if (wrapper) {
      wrapper.classList.add(
        'is-zero-results'
      );
    }

    if (message) {
      message.hidden = false;

      message.textContent =
        'No products match these filters.';
    }

    return;
  }

  var nextLabel =
    'View Products';

  if (Number.isFinite(count)) {

    nextLabel =
      'View ' +
      count +
      (
        count === 1
          ? ' Product'
          : ' Products'
      );
  }

  button.textContent =
    nextLabel;

  button.setAttribute(
    'data-ofv-filter-button-mode',
    'view'
  );

  button.setAttribute(
    'aria-label',
    nextLabel
  );

  if (wrapper) {

    wrapper.classList.remove(
      'is-zero-results'
    );
  }

  if (message) {

    message.hidden = true;
  }
}

  function getNativeDrawerHeaderCloseButton(drawer) {
    if (!drawer) return null;

    var scopes = [
      drawer.querySelector('.drawer__header'),
      drawer.querySelector('.drawer__fixed-header')
    ].filter(Boolean);

    var closeSelectors = [
      '.drawer__close',
      '.drawer__close-button',
      '.drawer__close-btn',
      '.js-drawer-close',
      '[data-drawer-close]',
      '[data-close-drawer]',
      '[data-drawer-close-button]',
      'button[aria-label*="Close"]',
      'button[aria-label*="close"]',
      '[role="button"][aria-label*="Close"]',
      '[role="button"][aria-label*="close"]'
    ];

    for (var s = 0; s < scopes.length; s += 1) {
      var scope = scopes[s];

      for (var i = 0; i < closeSelectors.length; i += 1) {
        var candidate = scope.querySelector(closeSelectors[i]);

        if (
          candidate &&
          !candidate.classList.contains('ofv-drawer-sticky-close') &&
          !candidate.closest('.ofv-drawer-active-filter-bar')
        ) {
          return candidate;
        }
      }

      var icon =
        scope.querySelector('.icon-close') ||
        scope.querySelector('.icon-close-small') ||
        scope.querySelector('[class*="icon-close"]');

      if (icon) {
        var iconControl = icon.closest('button, [role="button"], a');

        if (
          iconControl &&
          !iconControl.classList.contains('ofv-drawer-sticky-close') &&
          !iconControl.closest('.ofv-drawer-active-filter-bar')
        ) {
          return iconControl;
        }
      }
    }

    return null;
  }

  function getDrawerCloseButton(drawer) {
    if (!drawer) return null;

    var nativeHeaderClose =
      getNativeDrawerHeaderCloseButton(drawer);

    if (nativeHeaderClose) {
      return nativeHeaderClose;
    }

    var directMatch =
      drawer.querySelector('.drawer__close') ||
      drawer.querySelector('.drawer__close-button') ||
      drawer.querySelector('.drawer__close-btn') ||
      drawer.querySelector('.js-drawer-close') ||
      drawer.querySelector('[data-drawer-close]') ||
      drawer.querySelector('[data-close-drawer]') ||
      drawer.querySelector('[data-drawer-close-button]') ||
      drawer.querySelector(
        'button[aria-label*="Close"], button[aria-label*="close"]'
      ) ||
      drawer.querySelector(
        '[role="button"][aria-label*="Close"], [role="button"][aria-label*="close"]'
      );

    if (directMatch) return directMatch;

    var closeIcon =
      drawer.querySelector('.icon-close') ||
      drawer.querySelector('.icon-close-small') ||
      drawer.querySelector('[class*="icon-close"]') ||
      drawer.querySelector('svg[aria-label*="Close"]') ||
      drawer.querySelector('svg[aria-label*="close"]');

    if (closeIcon) {
      var iconControl = closeIcon.closest(
        'button, [role="button"], a'
      );

      if (iconControl) return iconControl;
    }

    var controls = drawer.querySelectorAll(
      'button, [role="button"]'
    );

    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      var label = (
        control.getAttribute('aria-label') ||
        control.getAttribute('title') ||
        control.textContent ||
        ''
      ).trim().toLowerCase();

      if (
        label === 'close' ||
        label.indexOf('close ') === 0 ||
        label === '×' ||
        label === 'x'
      ) {
        return control;
      }
    }

    return null;
  }

  function getVisibleDrawerOverlay(drawer) {
    var selectors = [
      '.drawer__overlay',
      '.drawer-overlay',
      '.js-drawer-close.drawer__overlay',
      '[data-drawer-overlay]',
      '[data-overlay]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var candidates = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < candidates.length; j += 1) {
        var candidate = candidates[j];

        if (drawer && drawer.contains(candidate)) continue;

        var style = window.getComputedStyle(candidate);
        var rect = candidate.getBoundingClientRect();

        if (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.width > 0 &&
          rect.height > 0
        ) {
          return candidate;
        }
      }
    }

    return null;
  }

  function clickLikeUser(element) {
    if (!element) return false;

    try {
      element.dispatchEvent(
        new MouseEvent('mousedown', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      element.dispatchEvent(
        new MouseEvent('mouseup', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      element.click();
      return true;
    } catch (error) {
      return false;
    }
  }

  function dispatchFullClickSequence(target, clientX, clientY) {
    if (!target) return false;

    var eventOptions = {
      bubbles: true,
      cancelable: true,
      view: window,
      clientX: clientX || 0,
      clientY: clientY || 0,
      button: 0,
      buttons: 1
    };

    try {
      if (window.PointerEvent) {
        target.dispatchEvent(new PointerEvent('pointerdown', eventOptions));
      }

      target.dispatchEvent(new MouseEvent('mousedown', eventOptions));

      if (window.PointerEvent) {
        target.dispatchEvent(new PointerEvent('pointerup', eventOptions));
      }

      target.dispatchEvent(new MouseEvent('mouseup', eventOptions));
      target.dispatchEvent(new MouseEvent('click', eventOptions));

      return true;
    } catch (error) {
      try {
        target.click();
        return true;
      } catch (clickError) {
        return false;
      }
    }
  }

  function clickActualOutsideArea(drawer) {
    if (!drawer) return false;

    var rect = drawer.getBoundingClientRect();
    var viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;

    var drawerCentre = rect.left + rect.width / 2;
    var x = drawerCentre < viewportWidth / 2
      ? viewportWidth - 4
      : 4;
    var y = Math.max(
      4,
      Math.min(viewportHeight - 4, viewportHeight / 2)
    );

    var outsideTarget = document.elementFromPoint(x, y);

    if (
      outsideTarget &&
      outsideTarget !== drawer &&
      !drawer.contains(outsideTarget)
    ) {
      return dispatchFullClickSequence(outsideTarget, x, y);
    }

    var candidates = document.elementsFromPoint
      ? document.elementsFromPoint(x, y)
      : [];

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];

      if (
        candidate &&
        candidate !== drawer &&
        !candidate.closest('.ofv-filter-apply__button')
      ) {
        return dispatchFullClickSequence(candidate, x, y);
      }
    }

    return false;
  }

  function closeDrawer(drawer) {

    if (clickActualOutsideArea(drawer)) {
      return true;
    }

    var closeButton = getDrawerCloseButton(drawer);

    if (closeButton) {
      try {
        closeButton.click();
        return true;
      } catch (error) {}
    }

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        keyCode: 27,
        which: 27,
        bubbles: true,
        cancelable: true
      })
    );

    return true;
  }

  function updateStickyCloseVisibility(drawer) {
    if (!drawer) return;

    var bar =
      drawer.querySelector(
        '.ofv-drawer-active-filter-bar'
      );

    if (!bar) return;

    var scroller =
      getDrawerScroller(drawer);

    var header =
      drawer.querySelector(
        '.drawer__header[data-ofv-filter-header-scrollable="true"]'
      ) ||
      drawer.querySelector(
        '.drawer__fixed-header[data-ofv-filter-header-scrollable="true"]'
      ) ||
      drawer.querySelector(
        '.drawer__header'
      );

    if (
      !scroller ||
      !header ||
      !header.getBoundingClientRect ||
      !scroller.getBoundingClientRect
    ) {
      bar.classList.remove(
        'is-header-out-of-view'
      );
      return;
    }

    var headerRect =
      header.getBoundingClientRect();

    var scrollerRect =
      scroller.getBoundingClientRect();

    var headerOutOfView =
      headerRect.bottom <=
      scrollerRect.top + 1;

    bar.classList.toggle(
      'is-header-out-of-view',
      headerOutOfView
    );
  }

  function ensureStickyCloseTracking(drawer) {
    if (!drawer) return;

    var scroller =
      getDrawerScroller(drawer);

    if (!scroller) return;

    updateStickyCloseVisibility(drawer);

    if (
      scroller.__ofvStickyCloseTrackingBound
    ) {
      return;
    }

    scroller.__ofvStickyCloseTrackingBound =
      true;

    scroller.addEventListener(
      'scroll',
      function () {
        var currentDrawer =
          getDrawer() || drawer;

        syncStickyBarToScrollport(
          currentDrawer
        );

        updateStickyCloseVisibility(
          currentDrawer
        );
      },
      { passive: true }
    );

    if (!window.__ofvStickyLayoutResizeBound) {
      window.__ofvStickyLayoutResizeBound = true;

      window.addEventListener(
        'resize',
        function () {
          var currentDrawer =
            getDrawer();

          if (!currentDrawer) return;

          syncStickyBarToScrollport(
            currentDrawer
          );

          alignFilterHeaderCloseWithFacetArrow(
            currentDrawer
          );

          updateStickyCloseVisibility(
            currentDrawer
          );
        },
        { passive: true }
      );
    }
  }

  function ensureViewButton() {
    var drawer = getDrawer();
    var form = getFilterForm(drawer);

    if (!drawer || !form) return null;

    prepareDrawerFacetPresentation(drawer);
    ensureDrawerLoadingSkeleton(drawer);
    ensureCaseInsensitiveColorGroups(drawer);
    ensureGroupedSizeFilters(drawer);
    hideZeroResultFilterOptions(drawer);
    removeSelectedFacetOptionCounts(drawer);
    ensureDrawerActiveFilterBar(drawer);
    ensureStickyCloseTracking(drawer);
    ensurePriceRangePersistence(drawer);
    consolidateToolbarGroupedFilterChips();

    var currentCount = getCurrentCount();
    var existing = form.querySelector('.ofv-filter-apply__button');

    if (existing) {
      var existingWrapper = existing.closest('.ofv-filter-apply');

      if (
        existingWrapper &&
        !existingWrapper.querySelector('.ofv-filter-zero-message')
      ) {
        var existingMessage = document.createElement('div');

        existingMessage.className = 'ofv-filter-zero-message';
        existingMessage.hidden = true;

        existingMessage.setAttribute(
          'role',
          'status'
        );

        existingMessage.setAttribute(
          'aria-live',
          'polite'
        );

        existingWrapper.insertBefore(
          existingMessage,
          existing
        );
      }

      setViewButtonCount(
        existing,
        currentCount
      );

      return existing;
    }

    var wrapper = document.createElement('div');

    wrapper.className = 'ofv-filter-apply';

    var message = document.createElement('div');

    message.className = 'ofv-filter-zero-message';

    message.textContent =
      'No products match these filters.';

    message.hidden = true;

    message.setAttribute(
      'role',
      'status'
    );

    message.setAttribute(
      'aria-live',
      'polite'
    );

    var button = document.createElement('button');

    button.type = 'button';

    button.className =
      'ofv-filter-apply__button';

    wrapper.appendChild(message);
    wrapper.appendChild(button);

    setViewButtonCount(
      button,
      currentCount
    );

    button.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        var latestCount =
          getCurrentCount();

        if (
          Number.isFinite(latestCount) &&
          latestCount === 0
        ) {
          cancelDrawerPersistence();

          var clearUrl =
            getClearFiltersUrl();

          if (clearUrl) {
            window.location.assign(
              clearUrl
            );
          }

          return;
        }

        cancelDrawerPersistence();

        window.requestAnimationFrame(
          function () {
            closeDrawer(
              getDrawer() || drawer
            );
          }
        );
      }
    );

    form.appendChild(wrapper);

    return button;
  }

  var viewButtonReadyTimer = null;
  var viewButtonReadyAttempt = 0;

  function ensureViewButtonWhenReady() {
    if (viewButtonReadyTimer) {
      window.clearTimeout(viewButtonReadyTimer);
      viewButtonReadyTimer = null;
    }

    viewButtonReadyAttempt = 0;

    function tryEnsureViewButton() {
      viewButtonReadyAttempt += 1;

      var button = ensureViewButton();

      if (button) {
        viewButtonReadyTimer = null;
        viewButtonReadyAttempt = 0;
        return;
      }

      if (viewButtonReadyAttempt >= 40) {
        viewButtonReadyTimer = null;
        viewButtonReadyAttempt = 0;
        return;
      }

      viewButtonReadyTimer = window.setTimeout(
        tryEnsureViewButton,
        100
      );
    }

    tryEnsureViewButton();
  }

  function normalizeFilterHeadingText(node) {
    return (node && node.textContent ? node.textContent : '')
      .replace(/\s+/g, ' ')
      .replace(/\(\s*\d+\s*\)\s*$/, '')
      .trim()
      .toLowerCase();
  }

  function getFilterTriggers(drawer) {
    if (!drawer) return [];

    return Array.prototype.slice.call(
      drawer.querySelectorAll(
        'button, summary, [role="button"], .collapsible-trigger'
      )
    );
  }

  function filterHeadingMatchesName(node, filterName) {
    if (!node || !filterName) return false;

    var targetName = String(filterName).trim().toLowerCase();
    var text = normalizeFilterHeadingText(node);

    var isMatch =
      text === targetName ||
      text.indexOf(targetName + ' ') === 0;

    if (
      targetName === 'color' &&
      (
        text === 'colour' ||
        text.indexOf('colour ') === 0
      )
    ) {
      isMatch = true;
    }

    return isMatch;
  }

  function resolveFacetTrigger(candidate, drawer, filterName) {
    if (!candidate) return null;

    var clickableSelector =
      'button, summary, [role="button"], .collapsible-trigger';

    if (
      candidate.matches &&
      candidate.matches(clickableSelector)
    ) {
      return candidate;
    }

    if (candidate.closest) {
      var closestClickable = candidate.closest(clickableSelector);

      if (
        closestClickable &&
        (!drawer || drawer.contains(closestClickable))
      ) {
        return closestClickable;
      }

      var details = candidate.closest('details');

      if (details) {
        var summary = details.querySelector('summary');
        if (summary) return summary;
      }
    }

    var node = candidate.parentElement;
    var depth = 0;

    while (node && node !== drawer && depth < 8) {
      var triggers = node.querySelectorAll(clickableSelector);

      for (var i = 0; i < triggers.length; i += 1) {
        if (filterHeadingMatchesName(triggers[i], filterName)) {
          return triggers[i];
        }
      }

      var previous = node.previousElementSibling;

      if (previous) {
        if (
          previous.matches &&
          previous.matches(clickableSelector) &&
          filterHeadingMatchesName(previous, filterName)
        ) {
          return previous;
        }

        var previousTriggers = previous.querySelectorAll
          ? previous.querySelectorAll(clickableSelector)
          : [];

        for (var j = 0; j < previousTriggers.length; j += 1) {
          if (filterHeadingMatchesName(previousTriggers[j], filterName)) {
            return previousTriggers[j];
          }
        }
      }

      node = node.parentElement;
      depth += 1;
    }

    return null;
  }

  function findFilterHeading(drawer, filterName) {
    if (!drawer || !filterName) return null;

    var clickableCandidates = drawer.querySelectorAll(
      'button, summary, [role="button"], .collapsible-trigger'
    );

    for (var i = 0; i < clickableCandidates.length; i += 1) {
      if (filterHeadingMatchesName(clickableCandidates[i], filterName)) {
        return clickableCandidates[i];
      }
    }

    var labelCandidates = drawer.querySelectorAll(
      'legend, h2, h3, h4, [data-filter-label], [class*="filter"][class*="title"]'
    );

    for (var j = 0; j < labelCandidates.length; j += 1) {
      if (!filterHeadingMatchesName(labelCandidates[j], filterName)) continue;

      var resolved = resolveFacetTrigger(
        labelCandidates[j],
        drawer,
        filterName
      );

      if (resolved) return resolved;
    }

    return null;
  }

  function findPriceFilterTrigger(drawer) {
    if (!drawer) return null;

    var direct = findFilterHeading(drawer, 'price');
    if (direct) return direct;

    var priceNode = drawer.querySelector(
      '.price-range__slider, .price-range__slider-wrapper, .price-range__display-wrapper, input[name*="price"]'
    );

    if (!priceNode) return null;

    var node = priceNode;
    var depth = 0;

    while (node && node !== drawer && depth < 10) {
      var resolved = resolveFacetTrigger(node, drawer, 'price');
      if (resolved) return resolved;

      node = node.parentElement;
      depth += 1;
    }

    return null;
  }

  function getControlledPanel(trigger) {
    if (!trigger) return null;

    var controlsId = trigger.getAttribute('aria-controls');

    if (controlsId) {
      var controlled = document.getElementById(controlsId);
      if (controlled) return controlled;
    }

    var next = trigger.nextElementSibling;
    if (next) return next;

    var parent = trigger.parentElement;
    if (!parent) return null;

    return parent.querySelector(
      '.collapsible-content, .collapsible-content__inner, [data-collapsible-content]'
    );
  }

  function isAccordionOpen(trigger) {
    if (!trigger) return false;

    if (
      trigger.tagName === 'SUMMARY' &&
      trigger.parentElement &&
      trigger.parentElement.tagName === 'DETAILS'
    ) {
      return trigger.parentElement.open;
    }

    if (trigger.getAttribute('aria-expanded') === 'true') {
      return true;
    }

    if (
      trigger.classList.contains('is-open') ||
      trigger.classList.contains('is-active') ||
      trigger.classList.contains('active')
    ) {
      return true;
    }

    var panel = getControlledPanel(trigger);

    if (panel) {
      if (panel.hidden) return false;
      if (panel.getAttribute('aria-hidden') === 'false') return true;

      if (
        panel.classList.contains('is-open') ||
        panel.classList.contains('is-active') ||
        panel.classList.contains('active')
      ) {
        return true;
      }

      var style = window.getComputedStyle(panel);

      if (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        panel.getBoundingClientRect().height > 2
      ) {
        return true;
      }
    }

    return false;
  }

  function openFilterAccordion(trigger) {
    if (!trigger) return false;

    if (
      trigger.tagName === 'SUMMARY' &&
      trigger.parentElement &&
      trigger.parentElement.tagName === 'DETAILS'
    ) {
      trigger.parentElement.open = true;
      return true;
    }

    var details = trigger.closest ? trigger.closest('details') : null;

    if (details) {
      details.open = true;

      var summary = details.querySelector('summary');
      if (summary) trigger = summary;
    }

    if (!isAccordionOpen(trigger)) {
      try {
        trigger.click();
      } catch (error) {
        return false;
      }
    }

    return true;
  }

  function getPrimaryFacetTriggerByName(drawer, filterName) {
    if (!drawer || !filterName) return null;

    return filterName === 'price'
      ? findPriceFilterTrigger(drawer)
      : findFilterHeading(drawer, filterName);
  }

  function scrollPrimaryFilterIntoView(drawer, heading, filterName) {
    if (!drawer || !heading) return;

    var scroller = getDrawerScroller(drawer);

    if (
      !scroller ||
      !scroller.getBoundingClientRect ||
      !heading.getBoundingClientRect
    ) {
      heading.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
      return;
    }
    if (filterName === 'size') {
      scroller.scrollTop = 0;
      return;
    }

    var scrollerRect = scroller.getBoundingClientRect();
    var headingRect = heading.getBoundingClientRect();
    var stickyBar = drawer.querySelector(
      '.ofv-drawer-active-filter-bar'
    );
    var stickyHeight = 0;
    var sortStickyHeight = 0;

    var sortSection = drawer.querySelector('.ofv-drawer-sort-section');
    var sortSummary = sortSection
      ? sortSection.querySelector('.ofv-drawer-sort__summary')
      : null;
    var sortIsOpen = !!(sortSummary && sortSummary.classList.contains('is-open'));

    if (sortSection && !sortIsOpen) {
      if (sortSummary && sortSummary.getBoundingClientRect) {
        sortStickyHeight = sortSummary.getBoundingClientRect().height || 0;
      }
    }

    if (stickyBar && stickyBar.getBoundingClientRect) {
      var stickyRect = stickyBar.getBoundingClientRect();
      var stickyStyle = window.getComputedStyle(stickyBar);

      if (
        stickyRect.height > 0 &&
        stickyStyle.display !== 'none' &&
        stickyStyle.visibility !== 'hidden'
      ) {
        stickyHeight = stickyRect.height;
      }
    }

    var nextScrollTop =
      scroller.scrollTop +
      (headingRect.top - scrollerRect.top) -
      stickyHeight -
      sortStickyHeight -
      8;

    scroller.scrollTop = Math.max(0, nextScrollTop);
  }

  function isDrawerReady(drawer) {
    if (!drawer) return false;

    var rect = drawer.getBoundingClientRect();
    var style = window.getComputedStyle(drawer);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  }

  function getDrawerScroller(drawer) {
    if (!drawer) return null;

    return (
      drawer.querySelector('.drawer__scrollable') ||
      drawer.querySelector('.drawer__inner') ||
      drawer.querySelector('[data-drawer-scroll]') ||
      drawer
    );
  }

  function getOpenFilterNames(drawer) {
    var names = [];
    var triggers = getFilterTriggers(drawer);

    triggers.forEach(function (trigger) {
      if (!isAccordionOpen(trigger)) return;

      var name = normalizeFilterHeadingText(trigger);

      if (!name) return;

      if (name === 'colour') name = 'color';

      if (names.indexOf(name) === -1) {
        names.push(name);
      }
    });

    return names;
  }

  function stripIds(node) {
    if (!node || !node.querySelectorAll) return;

    if (node.removeAttribute) {
      node.removeAttribute('id');
      node.removeAttribute('aria-controls');
      node.removeAttribute('aria-labelledby');
      node.removeAttribute('for');
    }

    var descendants = node.querySelectorAll('[id], [aria-controls], [aria-labelledby], [for]');

    descendants.forEach(function (element) {
      element.removeAttribute('id');
      element.removeAttribute('aria-controls');
      element.removeAttribute('aria-labelledby');
      element.removeAttribute('for');
    });
  }

  function removeDrawerGhost() {
    if (drawerRestoreTimer) {
      window.clearTimeout(drawerRestoreTimer);
      drawerRestoreTimer = null;
    }

    if (drawerGhost && drawerGhost.parentNode) {
      drawerGhost.parentNode.removeChild(drawerGhost);
    }

    drawerGhost = null;
    document.documentElement.classList.remove('ofv-filter-drawer-restoring');
    document.body.classList.remove('ofv-filter-drawer-restoring');
  }

  function createDrawerGhost(drawer) {
    removeDrawerGhost();

    if (!drawer || !isDrawerReady(drawer)) return;

    var rect = drawer.getBoundingClientRect();
    var computed = window.getComputedStyle(drawer);
    var clone = drawer.cloneNode(true);

    stripIds(clone);

    clone.classList.add('ofv-filter-drawer-ghost');

    if (drawer.classList.contains('ofv-is-filter-loading')) {
      clone.classList.add('ofv-is-filter-loading');
    }

    clone.setAttribute('aria-hidden', 'true');

    clone.style.position = 'fixed';
    clone.style.top = rect.top + 'px';
    clone.style.left = rect.left + 'px';
    clone.style.right = 'auto';
    clone.style.bottom = 'auto';
    clone.style.width = rect.width + 'px';
    clone.style.height = rect.height + 'px';
    clone.style.maxWidth = 'none';
    clone.style.maxHeight = 'none';
    clone.style.margin = '0';
    clone.style.transform = 'none';
    clone.style.transition = 'none';
    clone.style.animation = 'none';
    clone.style.opacity = '1';
    clone.style.visibility = 'visible';
    clone.style.display = computed.display === 'none' ? 'block' : computed.display;
    clone.style.zIndex = '2147483000';
    clone.style.overflow = 'hidden';

    document.body.appendChild(clone);
    drawerGhost = clone;
  }

  function cancelDrawerPersistence() {
    pendingDrawerState = null;
    removeDrawerGhost();
  }

  function captureDrawerState() {
    var drawer = getDrawer();

    if (!drawer || !isDrawerReady(drawer)) return;

    var scroller = getDrawerScroller(drawer);

    pendingDrawerState = {
      open: true,
      openFilters: getOpenFilterNames(drawer),
      scrollTop: scroller ? scroller.scrollTop : 0
    };

    createDrawerGhost(drawer);
  }

  function captureDrawerStateIfNeeded() {
    if (pendingDrawerState && pendingDrawerState.open) return;
    captureDrawerState();
  }

  function capturePriceRangeDrawerState() {
    if (pendingDrawerState && pendingDrawerState.open) return;

    var drawer = getDrawer();

    if (!drawer || !isDrawerReady(drawer)) return;

    var scroller = getDrawerScroller(drawer);

    pendingDrawerState = {
      open: true,
      openFilters: getOpenFilterNames(drawer),
      scrollTop: scroller ? scroller.scrollTop : 0
    };
  }

  function commitPriceRangeDrawerState() {
    var drawer = getDrawer();

    if (!drawer || !isDrawerReady(drawer)) return;

    if (!pendingDrawerState || !pendingDrawerState.open) {
      capturePriceRangeDrawerState();
    }

    showFilterLoadingSkeleton();
    createDrawerGhost(drawer);
  }

  function ensurePriceRangePersistence(drawer) {
    if (!drawer) return;

    var sliderElements = drawer.querySelectorAll('.price-range__slider');

    Array.prototype.forEach.call(sliderElements, function (sliderElement) {
      var slider = sliderElement.noUiSlider;

      if (!slider || slider.__ofvDrawerPersistenceBound) return;

      slider.__ofvDrawerPersistenceBound = true;

      slider.on('start', function () {
        capturePriceRangeDrawerState();
      });

      slider.on('change', function () {
        commitPriceRangeDrawerState();
      });
    });
  }

  function focusFilter(filterName) {
    var drawer = getDrawer();

    if (!drawer || !isDrawerReady(drawer)) return false;

    var heading = getPrimaryFacetTriggerByName(
      drawer,
      filterName
    );

    if (!heading) return false;

    if (!openFilterAccordion(heading)) return false;

    syncPrimaryFacetClosedGeometry(drawer);

    function reopenAndScrollToTarget() {
      var currentDrawer = getDrawer() || drawer;
      var currentHeading = getPrimaryFacetTriggerByName(
        currentDrawer,
        filterName
      );

      if (!currentHeading) return;

      openFilterAccordion(currentHeading);
      syncPrimaryFacetClosedGeometry(currentDrawer);
      scrollPrimaryFilterIntoView(
        currentDrawer,
        currentHeading,
        filterName
      );
    }

    window.requestAnimationFrame(reopenAndScrollToTarget);

    window.setTimeout(reopenAndScrollToTarget, 180);

    window.setTimeout(reopenAndScrollToTarget, 360);

    return true;
  }

  function queueFilterFocus(filterName) {
    var attempts = 0;

    function tryFocus() {
      attempts += 1;

      if (focusFilter(filterName)) return;
      if (attempts >= 18) return;

      window.setTimeout(tryFocus, 90);
    }

    window.setTimeout(tryFocus, 140);
  }

  function findAllFiltersOpener() {
    var buttons = document.querySelectorAll(
      '.js-drawer-open-collection-filters'
    );

    for (var i = 0; i < buttons.length; i += 1) {
      if (
        !buttons[i].matches('[data-ofv-open-color-filter]') &&
        !buttons[i].matches('[data-ofv-open-size-filter]') &&
        !buttons[i].matches('[data-ofv-open-price-filter]')
      ) {
        return buttons[i];
      }
    }

    return buttons.length ? buttons[0] : null;
  }

  function restoreDrawerAfterReload() {
    if (!pendingDrawerState || !pendingDrawerState.open) {
      removeDrawerGhost();
      return;
    }

    var state = pendingDrawerState;
    pendingDrawerState = null;

    document.documentElement.classList.add('ofv-filter-drawer-restoring');
    document.body.classList.add('ofv-filter-drawer-restoring');

    var opener = findAllFiltersOpener();

    if (!opener) {
      removeDrawerGhost();
      return;
    }

    opener.click();

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var drawer = getDrawer();

        if (!drawer) {
          removeDrawerGhost();
          return;
        }

        ensureViewButton();
        ensureDrawerActiveFilterBar(drawer);
        removeSelectedFacetOptionCounts(drawer);

        if (state.openFilters && state.openFilters.length) {
          state.openFilters.forEach(function (filterName) {
            var heading = findFilterHeading(drawer, filterName);
            if (heading) openFilterAccordion(heading);
          });
        }

        var scroller = getDrawerScroller(drawer);

        if (scroller && Number.isFinite(state.scrollTop)) {
  scroller.scrollTop = state.scrollTop;
}

drawerRestoreTimer = window.setTimeout(function () {

  var refreshedDrawer =
    getDrawer();

  if (
    refreshedDrawer &&
    isDrawerReady(refreshedDrawer)
  ) {

    var refreshedScroller =
      getDrawerScroller(
        refreshedDrawer
      );

    if (
      refreshedScroller &&
      Number.isFinite(
        state.scrollTop
      )
    ) {

      refreshedScroller.scrollTop =
        state.scrollTop;
    }

    syncStickyBarToScrollport(
      refreshedDrawer
    );

    alignFilterHeaderCloseWithFacetArrow(
      refreshedDrawer
    );

    syncPrimaryFacetClosedGeometry(
      refreshedDrawer
    );

    updateStickyCloseVisibility(
      refreshedDrawer
    );
  }

  removeDrawerGhost();

}, 240);
      });
    });
  }

  document.addEventListener(
    'input',
    function (event) {
      if (!isDrawerFilterField(event.target)) return;

      showFilterLoadingSkeleton();
      captureDrawerStateIfNeeded();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!isDrawerFilterField(event.target)) return;

      showFilterLoadingSkeleton();
      captureDrawerStateIfNeeded();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var drawer = getDrawer();
      if (!drawer || !isDrawerReady(drawer)) return;

      var closeTarget = event.target.closest(
        '.drawer__close, .drawer__close-button, .js-drawer-close, [data-drawer-close], [data-close-drawer]'
      );

      var isViewProducts = !!event.target.closest('.ofv-filter-apply__button');

      var clickedOutsideDrawer =
        !drawer.contains(event.target) &&
        !event.target.closest('.js-drawer-open-collection-filters');

      if (closeTarget || isViewProducts || clickedOutsideDrawer) {
        cancelDrawerPersistence();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var opener = event.target.closest(
        '.js-drawer-open-collection-filters'
      );

      if (!opener) return;

      ensureViewButtonWhenReady();

      window.setTimeout(function () {
        ensureDrawerActiveFilterBar(getDrawer());
      }, 120);

      window.setTimeout(function () {
        ensureDrawerActiveFilterBar(getDrawer());
      }, 420);

      if (opener.matches('[data-ofv-open-color-filter]')) {
        queueFilterFocus('color');
      }

      if (opener.matches('[data-ofv-open-size-filter]')) {
        queueFilterFocus('size');
      }

      if (opener.matches('[data-ofv-open-price-filter]')) {
        queueFilterFocus('price');
      }
    },
    true
  );

  document.addEventListener(
    'collection:reloaded',
    function () {
      clearFilterLoadingSkeleton();
      restoreDrawerAfterReload();
      window.setTimeout(function () {
        ensureViewButton();
        ensureDrawerActiveFilterBar(getDrawer());
      }, 0);

      window.setTimeout(function () {
        ensureViewButton();
        ensureDrawerActiveFilterBar(getDrawer());
        consolidateToolbarGroupedFilterChips();
      }, 200);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureViewButtonWhenReady();
      consolidateToolbarGroupedFilterChips();
    });
  } else {
    ensureViewButtonWhenReady();
    consolidateToolbarGroupedFilterChips();
  }

  document.addEventListener('shopify:section:load', function () {
    clearFilterLoadingSkeleton();
    ensureViewButtonWhenReady();
  });

  document.addEventListener('collection:reload-error', function () {
    clearFilterLoadingSkeleton();
    pendingDrawerState = null;
    removeDrawerGhost();
  });
  function applyDrawerSort(sortValue) {
    if (!sortValue) return;

    var drawer = getDrawer();
    var nativeSort = document.getElementById('SortBy');

    if (!nativeSort) return;

    showFilterLoadingSkeleton();

    if (drawer) {
      drawer.classList.add('ofv-is-sort-loading');
    }

    if (drawer && isDrawerReady(drawer)) {
      captureDrawerStateIfNeeded();
    }

    /* Use Impulse's own collection Sort listener. theme.js has been adjusted
       so that listener renders through AJAX instead of reloading the page. */
    nativeSort.value = sortValue;
    nativeSort.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  document.addEventListener(
    'change',
    function (event) {
      var sortRadio = event.target.closest
        ? event.target.closest(
            '#FilterDrawer input[data-ofv-drawer-sort]'
          )
        : null;

      if (!sortRadio || !sortRadio.checked) return;

      applyDrawerSort(sortRadio.value);
    },
    true
  );

  function keepDrawerSortAboveFooter() {
    var drawer = getDrawer();
    if (!drawer) return;

    var section = drawer.querySelector('.ofv-drawer-sort-section');
    var trigger = section
      ? section.querySelector('.ofv-drawer-sort__summary')
      : null;
    if (!section || !trigger || !trigger.classList.contains('is-open')) return;

    var scroller = getDrawerScroller(drawer);
    if (!scroller || !scroller.getBoundingClientRect) return;

    var sectionRect = section.getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();
    var viewBar = drawer.querySelector('.ofv-filter-apply');
    var visibleBottom = scrollerRect.bottom - 10;

    if (viewBar && viewBar.getBoundingClientRect) {
      var viewRect = viewBar.getBoundingClientRect();
      if (viewRect.height > 0) {
        visibleBottom = Math.min(visibleBottom, viewRect.top - 10);
      }
    }

    if (sectionRect.bottom > visibleBottom) {
      scroller.scrollTop += sectionRect.bottom - visibleBottom;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest
        ? event.target.closest('#FilterDrawer .ofv-drawer-sort__summary')
        : null;

      if (!summary) return;

      window.setTimeout(keepDrawerSortAboveFooter, 0);
      window.setTimeout(keepDrawerSortAboveFooter, 180);
      window.setTimeout(keepDrawerSortAboveFooter, 380);
    },
    true
  );
})();

(function () {
  'use strict';

  if (window.__ofvStickyCollectionToolbarV2) {
    return;
  }

  window.__ofvStickyCollectionToolbarV2 = true;

  var stickyId = 'OFVCollectionStickyToolbar';
  var rafId = null;
  var drawerObserver = null;

  var stickyDrawerPageScrollY = null;
  var stickyDrawerSessionActive = false;
  var stickyDrawerWasOpen = false;
  var scrollRestoreTimer = null;
  var stickyScrollGuardRaf = null;
  var stickyScrollGuardUntil = 0;
  var stickyScrollGuardTargetY = null;

  var stickyDrawerInitialFilterSignature = null;
  var stickyDrawerFiltersChanged = false;
  var stickyDrawerCloseHandled = false;

  var stickyDrawerSourceOpener = null;
  var stickyDrawerSourceOpenerOriginalFocus = null;
  var stickyDrawerSourceOpenerOriginalScrollIntoView = null;

  function getSourceToolbar() {
    return document.querySelector(
      '#CollectionAjaxContent .ofv-collection-toolbar'
    );
  }

  function getSourceGrid() {
    var toolbar = getSourceToolbar();

    if (!toolbar) return null;

    return toolbar.closest('.ofv-collection-grid');
  }

  function getFilterDrawer() {
    return document.getElementById('FilterDrawer');
  }

  function getDrawerFilterSignature(drawer) {
    if (!drawer) return '';

    var fields = drawer.querySelectorAll(
      'input[name^="filter."], select[name^="filter."], ' +
      'input[data-ofv-drawer-sort]'
    );

    var parts = [];

    Array.prototype.forEach.call(fields, function (field) {
      if (!field.name || field.disabled) return;

      var type = (field.type || '').toLowerCase();

      if (
        (type === 'checkbox' || type === 'radio') &&
        !field.checked
      ) {
        return;
      }

      if (field.tagName === 'SELECT' && field.multiple) {
        Array.prototype.forEach.call(
          field.options,
          function (option) {
            if (option.selected) {
              parts.push(
                field.name + '=' + option.value
              );
            }
          }
        );
        return;
      }

      parts.push(
        field.name + '=' + String(field.value || '')
      );
    });

    parts.sort();

    return parts.join('&');
  }

  function stickyDrawerHasFilterChanges() {
    if (!stickyDrawerSessionActive) return false;

    if (stickyDrawerFiltersChanged) return true;

    var currentSignature =
      getDrawerFilterSignature(getFilterDrawer());

    return (
      stickyDrawerInitialFilterSignature !== null &&
      currentSignature !== stickyDrawerInitialFilterSignature
    );
  }

  function suppressStickySourceOpenerScroll(button) {
    if (!button) return;

    restoreStickySourceOpenerScrollBehavior();

    stickyDrawerSourceOpener = button;
    stickyDrawerSourceOpenerOriginalFocus = button.focus;
    stickyDrawerSourceOpenerOriginalScrollIntoView =
      button.scrollIntoView;

    button.focus = function () {
      try {
        HTMLElement.prototype.focus.call(
          button,
          { preventScroll: true }
        );
      } catch (error) {
        HTMLElement.prototype.focus.call(button);
        if (
          Number.isFinite(stickyDrawerPageScrollY)
        ) {
          window.scrollTo(
            0,
            stickyDrawerPageScrollY
          );
        }
      }
    };

    button.scrollIntoView = function () {

    };
  }

  function restoreStickySourceOpenerScrollBehavior() {
    if (!stickyDrawerSourceOpener) return;

    if (stickyDrawerSourceOpenerOriginalFocus) {
      stickyDrawerSourceOpener.focus =
        stickyDrawerSourceOpenerOriginalFocus;
    } else {
      delete stickyDrawerSourceOpener.focus;
    }

    if (stickyDrawerSourceOpenerOriginalScrollIntoView) {
      stickyDrawerSourceOpener.scrollIntoView =
        stickyDrawerSourceOpenerOriginalScrollIntoView;
    } else {
      delete stickyDrawerSourceOpener.scrollIntoView;
    }

    stickyDrawerSourceOpener = null;
    stickyDrawerSourceOpenerOriginalFocus = null;
    stickyDrawerSourceOpenerOriginalScrollIntoView = null;
  }

  function getFilteredResultsTop() {
    var toolbar = getSourceToolbar();
    var grid = getSourceGrid();
    var target = toolbar || grid;

    if (!target) return 0;

    var top =
      target.getBoundingClientRect().top +
      (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      ) -
      getVisibleHeaderBottom();

    return Math.max(0, Math.round(top));
  }

  function resetStickyDrawerSession() {
    stickyDrawerSessionActive = false;
    stickyDrawerPageScrollY = null;
    stickyDrawerWasOpen = false;

    stickyDrawerInitialFilterSignature = null;
    stickyDrawerFiltersChanged = false;
    stickyDrawerCloseHandled = false;

    restoreStickySourceOpenerScrollBehavior();
  }

  function scrollToFilteredResultsTop() {
    stopStickyDrawerScrollGuard();

    var scrollToTop = function () {
      window.scrollTo(
        0,
        getFilteredResultsTop()
      );
    };

    window.requestAnimationFrame(scrollToTop);
    window.setTimeout(scrollToTop, 100);
    window.setTimeout(scrollToTop, 300);

    window.setTimeout(function () {
      resetStickyDrawerSession();
      scheduleStickyUpdate();
    }, 360);
  }

  function finishStickyDrawerClose() {
    if (
      !stickyDrawerSessionActive ||
      stickyDrawerCloseHandled
    ) {
      return;
    }

    stickyDrawerCloseHandled = true;

    if (stickyDrawerHasFilterChanges()) {

      scrollToFilteredResultsTop();
      return;
    }

    startStickyDrawerScrollGuard();

    window.setTimeout(function () {
      restoreStickySourceOpenerScrollBehavior();
    }, 560);
  }

  function nodeLooksVisible(node) {
    if (!node) return false;

    var style = window.getComputedStyle(node);
    var rect = node.getBoundingClientRect();

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity || '1') === 0
    ) {
      return false;
    }

    if (rect.width < 2 || rect.height < 2) {
      return false;
    }

    if (
      rect.right <= 1 ||
      rect.left >= window.innerWidth - 1 ||
      rect.bottom <= 1 ||
      rect.top >= window.innerHeight - 1
    ) {
      return false;
    }

    return true;
  }

  function isFilterDrawerOpen() {
    var drawer = getFilterDrawer();
    var ghost = document.querySelector('.ofv-filter-drawer-ghost');

    /* Keep the sticky toolbar suppressed for the full FilterDrawer lifecycle.
       Impulse uses drawer--is-open; is-transitioning covers opening/closing frames. */
    if (
      document.documentElement.classList.contains('ofv-filter-drawer-restoring') ||
      document.body.classList.contains('ofv-filter-drawer-restoring')
    ) {
      return true;
    }

    if (drawer) {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        return true;
      }

      if (
        drawer.classList.contains('drawer--is-open') ||
        drawer.classList.contains('is-transitioning') ||
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('is-active') ||
        drawer.classList.contains('active')
      ) {
        return true;
      }

      if (nodeLooksVisible(drawer)) {
        return true;
      }
    }

    if (ghost && nodeLooksVisible(ghost)) {
      return true;
    }

    return false;
  }

  function stopStickyDrawerScrollGuard() {
    if (stickyScrollGuardRaf !== null) {
      window.cancelAnimationFrame(stickyScrollGuardRaf);
      stickyScrollGuardRaf = null;
    }

    window.removeEventListener(
      'scroll',
      enforceStickyDrawerScrollPosition,
      true
    );

    stickyScrollGuardUntil = 0;
    stickyScrollGuardTargetY = null;
  }

  function enforceStickyDrawerScrollPosition() {
    if (!Number.isFinite(stickyScrollGuardTargetY)) return;

    var currentY =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (Math.abs(currentY - stickyScrollGuardTargetY) > 1) {
      window.scrollTo(0, stickyScrollGuardTargetY);
    }
  }

  function runStickyDrawerScrollGuardFrame() {
    enforceStickyDrawerScrollPosition();

    if (
      window.performance.now() <
      stickyScrollGuardUntil
    ) {
      stickyScrollGuardRaf =
        window.requestAnimationFrame(
          runStickyDrawerScrollGuardFrame
        );
      return;
    }

    stopStickyDrawerScrollGuard();

    window.setTimeout(function () {
      if (
        stickyDrawerSessionActive &&
        stickyDrawerCloseHandled &&
        !stickyDrawerHasFilterChanges()
      ) {
        resetStickyDrawerSession();
      }

      scheduleStickyUpdate();
    }, 20);
  }

  function startStickyDrawerScrollGuard() {
    if (
      !stickyDrawerSessionActive ||
      !Number.isFinite(stickyDrawerPageScrollY)
    ) {
      return;
    }

    stopStickyDrawerScrollGuard();

    stickyScrollGuardTargetY =
      stickyDrawerPageScrollY;

    stickyScrollGuardUntil =
      window.performance.now() + 520;

    window.addEventListener(
      'scroll',
      enforceStickyDrawerScrollPosition,
      true
    );

    enforceStickyDrawerScrollPosition();

    stickyScrollGuardRaf =
      window.requestAnimationFrame(
        runStickyDrawerScrollGuardFrame
      );
  }

  function restoreStickyDrawerPageScroll() {
    startStickyDrawerScrollGuard();
  }

  function closeAllCustomSortMenus(exceptUi) {
    var menus = document.querySelectorAll(
      '.ofv-custom-sort'
    );

    Array.prototype.forEach.call(
      menus,
      function (ui) {
        if (exceptUi && ui === exceptUi) return;

        ui.classList.remove('is-open');

        var trigger = ui.querySelector(
          '[data-ofv-custom-sort-trigger]'
        );

        var menu = ui.querySelector(
          '[data-ofv-custom-sort-menu]'
        );

        if (trigger) {
          trigger.setAttribute(
            'aria-expanded',
            'false'
          );
        }

        if (menu) {
          menu.hidden = true;
        }
      }
    );
  }

  function getCustomSortSelect(ui) {
    if (!ui) return null;

    var kind = ui.getAttribute(
      'data-ofv-sort-kind'
    );

    if (kind === 'sticky') {
      var sticky = document.getElementById(
        stickyId
      );

      return sticky
        ? sticky.querySelector(
            '[data-ofv-sticky-sort]'
          )
        : null;
    }

    var sourceToolbar = getSourceToolbar();

    return sourceToolbar
      ? sourceToolbar.querySelector(
          '#SortBy'
        )
      : null;
  }

  function syncCustomSortUi(select, kind) {
    if (!select || !select.parentNode) return null;

    select.classList.add(
      'ofv-sort-native-hidden'
    );

    select.setAttribute(
      'aria-hidden',
      'true'
    );

    select.setAttribute(
      'tabindex',
      '-1'
    );

    var parent = select.parentNode;

    var ui = parent.querySelector(
      '.ofv-custom-sort[data-ofv-sort-kind="' +
      kind +
      '"]'
    );

    if (!ui) {
      ui = document.createElement('div');
      ui.className = 'ofv-custom-sort';
      ui.setAttribute(
        'data-ofv-sort-kind',
        kind
      );

      ui.innerHTML =
        '<button type="button" class="ofv-custom-sort__trigger" data-ofv-custom-sort-trigger aria-haspopup="listbox" aria-expanded="false">' +
          '<span class="ofv-custom-sort__value" data-ofv-custom-sort-value></span>' +
          '<span class="ofv-custom-sort__arrow" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="ofv-custom-sort__menu" data-ofv-custom-sort-menu role="listbox" hidden></div>';

      parent.appendChild(ui);
    }

    var valueNode = ui.querySelector(
      '[data-ofv-custom-sort-value]'
    );

    var menu = ui.querySelector(
      '[data-ofv-custom-sort-menu]'
    );

    if (!valueNode || !menu) return ui;

    var signature = Array.prototype.map.call(
      select.options,
      function (option) {
        return (
          option.value +
          '||' +
          option.textContent
        );
      }
    ).join('___');

    if (
      menu.getAttribute(
        'data-ofv-options'
      ) !== signature
    ) {
      menu.innerHTML = '';

      Array.prototype.forEach.call(
        select.options,
        function (option) {
          var item =
            document.createElement(
              'button'
            );

          item.type = 'button';
          item.className =
            'ofv-custom-sort__option';

          item.setAttribute(
            'data-ofv-custom-sort-option',
            option.value
          );

          item.setAttribute(
            'role',
            'option'
          );

          item.textContent =
            option.textContent;

          menu.appendChild(item);
        }
      );

      menu.setAttribute(
        'data-ofv-options',
        signature
      );
    }

    var selectedOption =
      select.options[
        select.selectedIndex
      ];

    valueNode.textContent =
      selectedOption
        ? selectedOption.textContent
        : '';

    var items = menu.querySelectorAll(
      '[data-ofv-custom-sort-option]'
    );

    Array.prototype.forEach.call(
      items,
      function (item) {
        var selected =
          item.getAttribute(
            'data-ofv-custom-sort-option'
          ) === select.value;

        item.classList.toggle(
          'is-selected',
          selected
        );

        item.setAttribute(
          'aria-selected',
          selected ? 'true' : 'false'
        );
      }
    );

    return ui;
  }

  function createStickyToolbar() {
    var existing = document.getElementById(stickyId);

    if (existing) return existing;

    var sticky = document.createElement('div');

    sticky.id = stickyId;
    sticky.className = 'ofv-sticky-collection-toolbar';
    sticky.hidden = true;
    sticky.setAttribute('aria-label', 'Collection filters and sorting');

    sticky.innerHTML =
      '<div class="ofv-sticky-toolbar__filters">' +
        '<button type="button" class="ofv-sticky-toolbar__shortcut" data-ofv-sticky-target="size">Size</button>' +
        '<button type="button" class="ofv-sticky-toolbar__shortcut" data-ofv-sticky-target="color">Color</button>' +
        '<button type="button" class="ofv-sticky-toolbar__shortcut" data-ofv-sticky-target="price">Price</button>' +
        '<button type="button" class="ofv-sticky-toolbar__shortcut" data-ofv-sticky-target="filter">' +
          '<span>Filter &amp; Sort</span>' +
          '<span class="ofv-sticky-toolbar__filter-count" data-ofv-sticky-filter-count></span>' +
          '<svg class="ofv-filter-sort-icon" aria-hidden="true" focusable="false" viewBox="0 0 18 18"><path d="M2 4h7.15M13.25 4H16M2 9h2.25M8.35 9H16M2 14h7.15M13.25 14H16"></path><circle cx="11.2" cy="4" r="2.05"></circle><circle cx="6.3" cy="9" r="2.05"></circle><circle cx="11.2" cy="14" r="2.05"></circle></svg>' +
        '</button>' +
      '</div>' +
      '<div class="ofv-sticky-toolbar__chips" data-ofv-sticky-chips hidden></div>' +
      '<div class="ofv-sticky-toolbar__sort" data-ofv-sticky-sort-wrap>' +
        '<label class="ofv-sticky-toolbar__sort-label" for="OFVStickySortBy">Sort by:</label>' +
        '<select id="OFVStickySortBy" class="ofv-sticky-toolbar__sort-select" data-ofv-sticky-sort aria-label="Sort products"></select>' +
      '</div>';

    sticky.addEventListener('click',function(e){var a=e.target.closest('[data-ofv-sticky-chip]');if(!a)return;var source=getSourceToolbar(),list=source&&source.querySelectorAll('.ofv-toolbar-active-filters .ofv-active-filter');if(!list)return;for(var i=0;i<list.length;i++){if(list[i].href===a.href){e.preventDefault();list[i].click();break;}}});
    document.body.appendChild(sticky);

    return sticky;
  }

  function copyToolbarVariables(sourceGrid, sticky) {
    if (!sourceGrid || !sticky) return;

    var styles = window.getComputedStyle(sourceGrid);

    [
      '--ofv-toolbar-font-size',
      '--ofv-toolbar-font-weight',
      '--ofv-toolbar-font-style',
      '--ofv-toolbar-text-transform'
    ].forEach(function (name) {
      var value = styles.getPropertyValue(name);

      if (value) {
        sticky.style.setProperty(name, value.trim());
      }
    });
  }

  function getVisibleHeaderBottom() {
    var selectors = [
      '#HeaderWrapper',
      '#SiteHeader',
      '[data-section-type="header"] > .toolbar',
      '[data-section-type="header"] .toolbar',
      '.announcement-bar'
    ];

    var seen = [];
    var bottom = 0;

    selectors.forEach(function (selector) {
      var nodes = document.querySelectorAll(selector);

      Array.prototype.forEach.call(nodes, function (node) {
        if (!node || seen.indexOf(node) !== -1) return;

        seen.push(node);

        var rect = node.getBoundingClientRect();

        if (
          rect.height > 0 &&
          rect.bottom > 0 &&
          rect.top <= 2 &&
          rect.top < window.innerHeight
        ) {
          bottom = Math.max(bottom, rect.bottom);
        }
      });
    });

    return Math.max(0, Math.round(bottom));
  }

  function getSourceButton(sourceToolbar, target) {
    if (!sourceToolbar) return null;

    if (target === 'size') {
      return sourceToolbar.querySelector(
        '.js-drawer-open-collection-filters[data-ofv-open-size-filter]'
      );
    }

    if (target === 'color') {
      return sourceToolbar.querySelector(
        '.js-drawer-open-collection-filters[data-ofv-open-color-filter]'
      );
    }

    if (target === 'price') {
      return sourceToolbar.querySelector(
        '.js-drawer-open-collection-filters[data-ofv-open-price-filter]'
      );
    }

    return sourceToolbar.querySelector(
      '.ofv-toolbar-all-filters .js-drawer-open-collection-filters'
    ) || sourceToolbar.querySelector(
      '.js-drawer-open-collection-filters:not([data-ofv-open-size-filter]):not([data-ofv-open-color-filter]):not([data-ofv-open-price-filter])'
    );
  }

  function sourceControlIsAvailable(button) {
    if (!button) return false;

    var wrap =
      button.closest('.ofv-toolbar-size-shortcut-wrap') ||
      button.closest('.ofv-toolbar-color-shortcut-wrap') ||
      button.closest('.ofv-toolbar-price-shortcut-wrap') ||
      button.closest('.ofv-toolbar-all-filters') ||
      button;

    var style = window.getComputedStyle(wrap);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  }

  function getFilterCountText(sourceToolbar) {
    if (!sourceToolbar) return '';

    var countNode = sourceToolbar.querySelector(
      '.ofv-toolbar-all-filters .ofv-toolbar-control__count'
    );

    if (!countNode) return '';

    return countNode.textContent.trim();
  }

  function syncStickyFilterButtons(sourceToolbar, sticky) {
    if (!sourceToolbar || !sticky) return;

    var buttons = sticky.querySelectorAll(
      '[data-ofv-sticky-target]'
    );

    Array.prototype.forEach.call(buttons, function (button) {
      var target = button.getAttribute('data-ofv-sticky-target');
      var sourceButton = getSourceButton(sourceToolbar, target);

      button.hidden = !sourceControlIsAvailable(sourceButton);
    });

    var filterCount = sticky.querySelector(
      '[data-ofv-sticky-filter-count]'
    );

    if (filterCount) {
      filterCount.textContent = getFilterCountText(sourceToolbar);
    }
  }

  function syncStickyChips(sourceToolbar, sticky) {
    var wrap=sticky&&sticky.querySelector('[data-ofv-sticky-chips]');
    if(!wrap)return;
    if(window.innerWidth<=768){wrap.hidden=true;wrap.innerHTML='';return;}
    var source=sourceToolbar&&sourceToolbar.querySelector('.ofv-toolbar-active-filters');
    var chips=source?Array.prototype.filter.call(source.querySelectorAll('.ofv-active-filter:not(.ofv-active-filter--clear)'),function(a){return a.getAttribute('aria-hidden')!=='true'&&window.getComputedStyle(a).display!=='none';}):[];
    wrap.innerHTML='';
    chips.forEach(function(a){var c=document.createElement('a'),label=a.querySelector('.ofv-active-filter__label');c.href=a.href;c.className='ofv-sticky-filter-chip';c.setAttribute('data-ofv-sticky-chip','');c.innerHTML='<span></span><b aria-hidden="true">×</b>';c.querySelector('span').textContent=label?label.textContent.trim():a.textContent.replace('×','').trim();wrap.appendChild(c);});
    if(chips.length){var clear=source&&source.querySelector('.ofv-active-filter--clear');if(clear){var c=document.createElement('a');c.href=clear.href;c.className='ofv-sticky-filter-clear';c.setAttribute('data-ofv-sticky-chip','');c.innerHTML='<span class="ofv-sticky-filter-clear__label">Clear All</span><span class="ofv-sticky-filter-clear__remove" aria-hidden="true">×</span>';wrap.appendChild(c);}}
    wrap.hidden=!chips.length;
  }

  function syncSort(sourceToolbar, sticky) {
    if (!sourceToolbar || !sticky) return;

    var sourceSelect = sourceToolbar.querySelector('#SortBy');
    var stickySelect = sticky.querySelector('[data-ofv-sticky-sort]');
    var sortWrap = sticky.querySelector('[data-ofv-sticky-sort-wrap]');

    if (!stickySelect || !sortWrap) return;

    if (!sourceSelect) {
      sortWrap.hidden = true;
      return;
    }

    sortWrap.hidden = false;

    var sourceOptions = Array.prototype.map.call(
      sourceSelect.options,
      function (option) {
        return option.value + '||' + option.text;
      }
    ).join('___');

    if (stickySelect.getAttribute('data-ofv-options') !== sourceOptions) {
      stickySelect.innerHTML = '';

      Array.prototype.forEach.call(
        sourceSelect.options,
        function (sourceOption) {
          var option = document.createElement('option');

          option.value = sourceOption.value;
          option.textContent = sourceOption.textContent;

          stickySelect.appendChild(option);
        }
      );

      stickySelect.setAttribute('data-ofv-options', sourceOptions);
    }

    stickySelect.value = sourceSelect.value;
  }

  function syncSortVisuals(sourceToolbar, sticky) {
    if (!sourceToolbar || !sticky) return;

    var sourceSelect = sourceToolbar.querySelector('#SortBy');
    var sourceLabel = sourceToolbar.querySelector('.ofv-sort-control__prefix');
    var sourceWrap = sourceToolbar.querySelector('.ofv-sort-control');

    var stickySelect = sticky.querySelector('[data-ofv-sticky-sort]');
    var stickyLabel = sticky.querySelector('.ofv-sticky-toolbar__sort-label');
    var stickyWrap = sticky.querySelector('.ofv-sticky-toolbar__sort');

    if (!sourceSelect || !stickySelect) return;

    var selectStyle = window.getComputedStyle(sourceSelect);
    var selectRect = sourceSelect.getBoundingClientRect();

    [
      'fontSize',
      'fontWeight',
      'fontStyle',
      'lineHeight',
      'letterSpacing',
      'textTransform',
      'color',
      'backgroundColor',
      'paddingTop',
      'paddingRight',
      'paddingBottom',
      'paddingLeft',
      'borderTopWidth',
      'borderRightWidth',
      'borderBottomWidth',
      'borderLeftWidth',
      'borderTopStyle',
      'borderRightStyle',
      'borderBottomStyle',
      'borderLeftStyle',
      'borderTopColor',
      'borderRightColor',
      'borderBottomColor',
      'borderLeftColor',
      'boxSizing'
    ].forEach(function (prop) {
      stickySelect.style[prop] = selectStyle[prop];
    });

    if (selectRect.height > 0) {
      stickySelect.style.height = Math.round(selectRect.height) + 'px';
      stickySelect.style.minHeight = Math.round(selectRect.height) + 'px';
    }

    stickySelect.style.outline = 'none';
    stickySelect.style.boxShadow = 'none';
    stickySelect.style.textOverflow = 'clip';
    stickySelect.style.whiteSpace = 'nowrap';

    if (sourceLabel && stickyLabel) {
      var labelStyle = window.getComputedStyle(sourceLabel);

      [
        'fontSize',
        'fontWeight',
        'fontStyle',
        'lineHeight',
        'letterSpacing',
        'textTransform',
        'color',
        'whiteSpace'
      ].forEach(function (prop) {
        stickyLabel.style[prop] = labelStyle[prop];
      });
    }

    if (sourceWrap && stickyWrap) {
      var wrapStyle = window.getComputedStyle(sourceWrap);
      var gap = wrapStyle.columnGap || wrapStyle.gap;

      if (gap) {
        stickyWrap.style.gap = gap;
      }
    }
  }

  function syncSourceToolbarSort(sourceToolbar) {
    if (!sourceToolbar) return;

    var sourceSelect =
      sourceToolbar.querySelector('#SortBy');

    syncCustomSortUi(
      sourceSelect,
      'source'
    );
  }

  function syncStickyContent(sourceToolbar, sourceGrid, sticky) {
    if (!sourceToolbar || !sourceGrid || !sticky) return;

    copyToolbarVariables(sourceGrid, sticky);
    syncStickyFilterButtons(sourceToolbar, sticky);
    syncStickyChips(sourceToolbar, sticky);
    syncSort(sourceToolbar, sticky);

    syncSourceToolbarSort(
      sourceToolbar
    );

    var stickySelect =
      sticky.querySelector(
        '[data-ofv-sticky-sort]'
      );

    syncCustomSortUi(
      stickySelect,
      'sticky'
    );
  }

  function positionStickyToolbar() {
    rafId = null;

    var sourceToolbar = getSourceToolbar();
    var sourceGrid = getSourceGrid();
    var sticky = createStickyToolbar();

    if (isFilterDrawerOpen()) {
      sticky.hidden = true;
      return;
    }

    if (!sourceToolbar || !sourceGrid || !sticky) {
      if (sticky) sticky.hidden = true;
      return;
    }

    var desktopStickyEnabled =
      sourceGrid.getAttribute(
        'data-ofv-sticky-desktop'
      ) !== 'false';

    var mobileStickyEnabled =
      sourceGrid.getAttribute(
        'data-ofv-sticky-mobile'
      ) !== 'false';

    var stickyEnabledForViewport =
      window.innerWidth <= 768
        ? mobileStickyEnabled
        : desktopStickyEnabled;
    syncSourceToolbarSort(
      sourceToolbar
    );

    if (!stickyEnabledForViewport) {
      sticky.hidden = true;
      return;
    }

    syncStickyContent(sourceToolbar, sourceGrid, sticky);

    var headerBottom = getVisibleHeaderBottom();
    var sourceRect = sourceToolbar.getBoundingClientRect();
    var gridRect = (sourceGrid.closest('#CollectionAjaxContent') || sourceGrid).getBoundingClientRect();

    sticky.style.top = headerBottom + 'px';

    var sourceLeft = Math.max(
      0,
      Math.round(sourceRect.left)
    );

    var sourceRight = Math.max(
      0,
      Math.round(
        window.innerWidth -
        sourceRect.right
      )
    );

    sticky.style.setProperty(
      'left',
      sourceLeft + 'px',
      'important'
    );

    sticky.style.setProperty(
      'right',
      'auto',
      'important'
    );

    sticky.style.setProperty(
      'width',
      Math.round(sourceRect.width) + 'px',
      'important'
    );

    sticky.style.setProperty(
      'padding-left',
      '0px',
      'important'
    );

    sticky.style.setProperty(
      'padding-right',
      '0px',
      'important'
    );

    var stickyHeight = sticky.offsetHeight || 50;

    var shouldShow =
      sourceRect.top <= headerBottom + 1 &&
      gridRect.bottom > headerBottom + stickyHeight + 12;

    sticky.hidden = !shouldShow;
  }

  function scheduleStickyUpdate() {
    if (rafId !== null) return;

    rafId = window.requestAnimationFrame(positionStickyToolbar);
  }

  function attachDrawerObserver() {
    var drawer = getFilterDrawer();

    if (!drawer || !window.MutationObserver) return;

    if (drawer.__ofvStickyToolbarObserved) return;

    drawer.__ofvStickyToolbarObserved = true;

    stickyDrawerWasOpen = isFilterDrawerOpen();

    drawerObserver = new MutationObserver(function () {
      var drawerIsOpenNow = isFilterDrawerOpen();

      if (
        stickyDrawerSessionActive &&
        stickyDrawerWasOpen &&
        !drawerIsOpenNow
      ) {
        finishStickyDrawerClose();
      }

      if (drawerIsOpenNow) {
        stickyDrawerWasOpen = true;
      }

      scheduleStickyUpdate();
    });

    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'aria-hidden'
      ]
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var stickyButton = event.target.closest(
        '#OFVCollectionStickyToolbar [data-ofv-sticky-target]'
      );

      if (!stickyButton) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var sticky = document.getElementById(stickyId);

      stickyDrawerPageScrollY =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      stickyDrawerSessionActive = true;
      stickyDrawerWasOpen = false;
      stickyDrawerCloseHandled = false;
      stickyDrawerFiltersChanged = false;

      stickyDrawerInitialFilterSignature =
        getDrawerFilterSignature(
          getFilterDrawer()
        );

      if (sticky) {
        sticky.hidden = true;
      }

      var sourceToolbar = getSourceToolbar();

      if (!sourceToolbar) return;

      var target = stickyButton.getAttribute(
        'data-ofv-sticky-target'
      );

      var sourceButton = getSourceButton(
        sourceToolbar,
        target
      );

      if (!sourceButton) return;

      suppressStickySourceOpenerScroll(
        sourceButton
      );

      window.requestAnimationFrame(function () {
        sourceButton.click();

        window.setTimeout(function () {
          attachDrawerObserver();
          scheduleStickyUpdate();
        }, 30);

        window.setTimeout(scheduleStickyUpdate, 180);
        window.setTimeout(scheduleStickyUpdate, 420);
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var opener = event.target.closest(
        '.js-drawer-open-collection-filters'
      );

      if (!opener) return;

      var sticky = document.getElementById(stickyId);

      if (sticky) {
        sticky.hidden = true;
      }

      window.setTimeout(function () {
        attachDrawerObserver();
        scheduleStickyUpdate();
      }, 30);

      window.setTimeout(scheduleStickyUpdate, 220);
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      if (!stickyDrawerSessionActive) return;

      if (
        event.target.matches(
          '#FilterDrawer input[name^="filter."], ' +
          '#FilterDrawer select[name^="filter."], ' +
          '#FilterDrawer input[data-ofv-drawer-sort]'
        )
      ) {
        stickyDrawerFiltersChanged = true;
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!stickyDrawerSessionActive) return;

      if (
        event.target.matches(
          '#FilterDrawer input[name^="filter."], ' +
          '#FilterDrawer select[name^="filter."], ' +
          '#FilterDrawer input[data-ofv-drawer-sort]'
        )
      ) {
        stickyDrawerFiltersChanged = true;
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!stickyDrawerSessionActive) return;

      var drawer = getFilterDrawer();
      if (!drawer) return;

      var closeTarget = event.target.closest(
        '#FilterDrawer .drawer__close, ' +
        '#FilterDrawer .drawer__close-button, ' +
        '#FilterDrawer .js-drawer-close, ' +
        '#FilterDrawer [data-drawer-close], ' +
        '#FilterDrawer [data-close-drawer], ' +
        '#FilterDrawer .ofv-filter-apply__button'
      );

      var clickedOutsideDrawer =
        !drawer.contains(event.target) &&
        !event.target.closest(
          '#OFVCollectionStickyToolbar, .js-drawer-open-collection-filters'
        );

      if (!closeTarget && !clickedOutsideDrawer) return;

      if (!stickyDrawerHasFilterChanges()) {
        startStickyDrawerScrollGuard();
      } else {
        stopStickyDrawerScrollGuard();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!stickyDrawerSessionActive) return;

      var drawer = getFilterDrawer();
      if (!drawer) return;

      var closeTarget = event.target.closest(
        '#FilterDrawer .drawer__close, ' +
        '#FilterDrawer .drawer__close-button, ' +
        '#FilterDrawer .js-drawer-close, ' +
        '#FilterDrawer [data-drawer-close], ' +
        '#FilterDrawer [data-close-drawer], ' +
        '#FilterDrawer .ofv-filter-apply__button'
      );

      var clickedOutsideDrawer =
        !drawer.contains(event.target) &&
        !event.target.closest(
          '#OFVCollectionStickyToolbar, .js-drawer-open-collection-filters'
        );

      if (!closeTarget && !clickedOutsideDrawer) return;

      if (!stickyDrawerHasFilterChanges()) {
        startStickyDrawerScrollGuard();
      } else {
        stopStickyDrawerScrollGuard();
      }

      window.setTimeout(
        finishStickyDrawerClose,
        180
      );

      window.setTimeout(scheduleStickyUpdate, 80);
      window.setTimeout(scheduleStickyUpdate, 260);
      window.setTimeout(scheduleStickyUpdate, 520);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        '[data-ofv-custom-sort-trigger]'
      );

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        var ui = trigger.closest(
          '.ofv-custom-sort'
        );

        if (!ui) return;

        var menu = ui.querySelector(
          '[data-ofv-custom-sort-menu]'
        );

        if (!menu) return;

        var willOpen = menu.hidden;

        closeAllCustomSortMenus(
          willOpen ? ui : null
        );

        ui.classList.toggle(
          'is-open',
          willOpen
        );

        trigger.setAttribute(
          'aria-expanded',
          willOpen ? 'true' : 'false'
        );

        menu.hidden = !willOpen;

        return;
      }

      var option = event.target.closest(
        '[data-ofv-custom-sort-option]'
      );

      if (option) {
        event.preventDefault();
        event.stopPropagation();

        var optionUi = option.closest(
          '.ofv-custom-sort'
        );

        var select =
          getCustomSortSelect(optionUi);

        if (!select) return;

        select.value = option.getAttribute(
          'data-ofv-custom-sort-option'
        );

        syncCustomSortUi(
          select,
          optionUi.getAttribute(
            'data-ofv-sort-kind'
          )
        );

        closeAllCustomSortMenus();

        select.dispatchEvent(
          new Event(
            'change',
            { bubbles: true }
          )
        );

        return;
      }

      closeAllCustomSortMenus();
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') return;

      closeAllCustomSortMenus();
    }
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target.matches(
          '#OFVCollectionStickyToolbar [data-ofv-sticky-sort]'
        )
      ) {
        return;
      }

      var sourceToolbar = getSourceToolbar();

      if (!sourceToolbar) return;

      var sourceSelect = sourceToolbar.querySelector('#SortBy');

      if (!sourceSelect) return;

      sourceSelect.value = event.target.value;

      sourceSelect.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    },
    true
  );

  window.addEventListener(
    'scroll',
    scheduleStickyUpdate,
    {
      passive: true
    }
  );

  window.addEventListener(
    'resize',
    scheduleStickyUpdate
  );

  document.addEventListener(
    'transitionend',
    function (event) {
      if (
        event.target &&
        (
          event.target.id === 'FilterDrawer' ||
          event.target.closest('#FilterDrawer')
        )
      ) {
        scheduleStickyUpdate();
      }
    },
    true
  );

  document.addEventListener(
    'collection:reloaded',
    function () {
      window.setTimeout(function () {
        attachDrawerObserver();

        var sourceToolbar =
          getSourceToolbar();

        if (sourceToolbar) {
          syncCustomSortUi(
            sourceToolbar.querySelector(
              '#SortBy'
            ),
            'source'
          );
        }

        scheduleStickyUpdate();
      }, 0);

      window.setTimeout(scheduleStickyUpdate, 220);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      attachDrawerObserver();
      scheduleStickyUpdate();
    }
  );

  if (window.MutationObserver) {
    var rootObserver = new MutationObserver(function () {
      scheduleStickyUpdate();
    });

    rootObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (document.body) {
      rootObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        attachDrawerObserver();

        var initialSourceToolbar =
          getSourceToolbar();

        if (initialSourceToolbar) {
          syncCustomSortUi(
            initialSourceToolbar.querySelector(
              '#SortBy'
            ),
            'source'
          );
        }

        scheduleStickyUpdate();
      },
      {
        once: true
      }
    );
  } else {
    attachDrawerObserver();

    var initialSourceToolbar =
      getSourceToolbar();

    if (initialSourceToolbar) {
      syncCustomSortUi(
        initialSourceToolbar.querySelector(
          '#SortBy'
        ),
        'source'
      );
    }

    scheduleStickyUpdate();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
